import React from "react";

export const Background = () => {
  return (
     <div
      className="player-animation"
      id="scene"
      data-hover-only="true"
      data-relative-input="true">
      <div
        className="layer layer-1"
        data-depth="0.10"
      >
        <svg
          id="player-layer-1"
          x="0px"
          y="0px"
          viewBox="0 0 1546.2 893.8">
          <g>
            <g className="st0">
              <line
                className="st1"
                x1="605.8"
                y1="244.5"
                x2="553.9"
                y2="274.5"/>
              <ellipse
                transform="matrix(0.5 -0.866 0.866 0.5 37.7041 616.8636)"
                className="st2"
                cx="553.1"
                cy="275.8"
                rx="7"
                ry="7"/>
              <line
                className="st1"
                x1="660.7"
                y1="274.3"
                x2="608.7"
                y2="244.3"/>
              <circle
                className="st2"
                cx="607.3"
                cy="244.3"
                r="7"/>
              <g>
                <line
                  className="st1"
                  x1="457.1"
                  y1="435.5"
                  x2="457.1"
                  y2="465.5"/>
                <line
                  className="st1"
                  x1="457.1"
                  y1="465.5"
                  x2="431.2"
                  y2="480.5"/>
                <line
                  className="st1"
                  x1="405.2"
                  y1="435.5"
                  x2="405.2"
                  y2="465.5"/>
                <line
                  className="st1"
                  x1="405.2"
                  y1="465.5"
                  x2="431.2"
                  y2="480.5"/>
                <line
                  className="st1"
                  x1="405.2"
                  y1="435.5"
                  x2="431.2"
                  y2="420.5"/>
                <line
                  className="st1"
                  x1="457.1"
                  y1="435.5"
                  x2="431.2"
                  y2="420.5"/>
              </g>
              <line
                className="st1"
                x1="412.2"
                y1="440.5"
                x2="412.2"
                y2="460.5"/>
              <line
                className="st1"
                x1="449.3"
                y1="461.9"
                x2="432"
                y2="471.9"/>
              <line
                className="st1"
                x1="449.3"
                y1="439"
                x2="432"
                y2="429"/>
              <g>
                <line
                  className="st1"
                  x1="405.2"
                  y1="435.5"
                  x2="405.2"
                  y2="465.5"/>
                <line
                  className="st1"
                  x1="405.2"
                  y1="465.5"
                  x2="379.2"
                  y2="480.5"/>
                <line
                  className="st1"
                  x1="353.2"
                  y1="435.5"
                  x2="353.2"
                  y2="465.5"/>
                <line
                  className="st1"
                  x1="353.2"
                  y1="465.5"
                  x2="379.2"
                  y2="480.5"/>
                <line
                  className="st1"
                  x1="353.2"
                  y1="435.5"
                  x2="379.2"
                  y2="420.5"/>
                <line
                  className="st1"
                  x1="405.2"
                  y1="435.5"
                  x2="379.2"
                  y2="420.5"/>
              </g>
              <line
                className="st1"
                x1="378.4"
                y1="429"
                x2="361"
                y2="439"/>
              <line
                className="st1"
                x1="432"
                y1="400.5"
                x2="432"
                y2="420.5"/>
              <line
                className="st1"
                x1="458"
                y1="384.1"
                x2="432"
                y2="399.1"/>
              <line
                className="st1"
                x1="406"
                y1="384.1"
                x2="432"
                y2="399.1"/>
              <line
                className="st1"
                x1="457.5"
                y1="465.5"
                x2="474.8"
                y2="475.5"/>
              <line
                className="st1"
                x1="353.2"
                y1="465.5"
                x2="335.9"
                y2="475.5"/>
              <line
                className="st1"
                x1="550"
                y1="528"
                x2="550"
                y2="558"/>
              <line
                className="st1"
                x1="550"
                y1="528"
                x2="576"
                y2="513"/>
              <line
                className="st1"
                x1="550"
                y1="528"
                x2="524"
                y2="513"/>
              <circle
                className="st2"
                cx="524"
                cy="513"
                r="7"/>
              <circle
                className="st2"
                cx="550"
                cy="558"
                r="7"/>
              <circle
                className="st2"
                cx="576"
                cy="513"
                r="7"/>
              <line
                className="st1"
                x1="711.4"
                y1="620"
                x2="741.4"
                y2="568"/>
              <line
                className="st1"
                x1="711.4"
                y1="620"
                x2="651.4"
                y2="620"/>
              <line
                className="st1"
                x1="711.4"
                y1="620"
                x2="741.4"
                y2="671.9"/>
              <circle
                className="st2"
                cx="711.4"
                cy="620"
                r="21"/>
              <circle
                className="st2"
                cx="741.4"
                cy="566.6"
                r="7"/>
              <circle
                className="st2"
                cx="651.4"
                cy="620"
                r="7"/>
              <line
                className="st1"
                x1="767.4"
                y1="686.1"
                x2="767.4"
                y2="716.1"/>
              <line
                className="st1"
                x1="767.4"
                y1="686.1"
                x2="793.3"
                y2="671.1"/>
              <line
                className="st1"
                x1="767.4"
                y1="686.1"
                x2="741.4"
                y2="671.1"/>
              <circle
                className="st2"
                cx="741.4"
                cy="671.1"
                r="7"/>
              <circle
                className="st2"
                cx="767.4"
                cy="716.1"
                r="7"/>
              <circle
                className="st2"
                cx="793.3"
                cy="671.1"
                r="7"/>
              <line
                className="st1"
                x1="1023.4"
                y1="408.1"
                x2="971.4"
                y2="438.1"/>
              <line
                className="st1"
                x1="1023.4"
                y1="408.1"
                x2="1075.4"
                y2="438.1"/>
              <ellipse
                transform="matrix(0.5 -0.866 0.866 0.5 158.2707 1090.3652)"
                className="st2"
                cx="1023.4"
                cy="408.1"
                rx="21"
                ry="21"/>
              <ellipse
                transform="matrix(0.5 -0.866 0.866 0.5 104.8678 1060.3438)"
                className="st2"
                cx="970.7"
                cy="439.4"
                rx="7"
                ry="7"/>
              <line
                className="st1"
                x1="1075.4"
                y1="469"
                x2="1049.4"
                y2="484"/>
              <line
                className="st1"
                x1="1075.4"
                y1="469"
                x2="1101.4"
                y2="484"/>
              <line
                className="st1"
                x1="1075.4"
                y1="469"
                x2="1075.4"
                y2="439"/>
              <ellipse
                transform="matrix(0.866 -0.5 0.5 0.866 -75.4137 596.5107)"
                className="st2"
                cx="1075.4"
                cy="439"
                rx="7"
                ry="7"/>
              <ellipse
                transform="matrix(0.866 -0.5 0.5 0.866 -101.4015 589.5424)"
                className="st2"
                cx="1049.4"
                cy="484"
                rx="7"
                ry="7"/>
              <ellipse
                transform="matrix(0.866 -0.5 0.5 0.866 -94.4257 615.5371)"
                className="st2"
                cx="1101.4"
                cy="484"
                rx="7"
                ry="7"/>
              <g>
                <line
                  className="st1"
                  x1="976.4"
                  y1="238"
                  x2="976.4"
                  y2="268"/>
                <line
                  className="st1"
                  x1="976.4"
                  y1="268"
                  x2="950.4"
                  y2="283"/>
                <line
                  className="st1"
                  x1="924.4"
                  y1="238"
                  x2="924.4"
                  y2="268"/>
                <line
                  className="st1"
                  x1="924.4"
                  y1="268"
                  x2="950.4"
                  y2="283"/>
                <line
                  className="st1"
                  x1="924.4"
                  y1="238"
                  x2="950.4"
                  y2="223"/>
                <line
                  className="st1"
                  x1="976.4"
                  y1="238"
                  x2="950.4"
                  y2="223"/>
              </g>
              <line
                className="st1"
                x1="949.6"
                y1="231.5"
                x2="932.3"
                y2="241.5"/>
              <line
                className="st1"
                x1="976.4"
                y1="268"
                x2="993.7"
                y2="278"/>
              <line
                className="st1"
                x1="993.7"
                y1="278"
                x2="993.7"
                y2="308"/>
              <line
                className="st1"
                x1="986.7"
                y1="283"
                x2="986.7"
                y2="303"/>
              <line
                className="st1"
                x1="924.4"
                y1="238.1"
                x2="898.4"
                y2="223.1"/>
              <g>
                <line
                  className="st1"
                  x1="891"
                  y1="597.3"
                  x2="906"
                  y2="571.3"/>
                <line
                  className="st1"
                  x1="906"
                  y1="571.3"
                  x2="936"
                  y2="571.3"/>
                <line
                  className="st1"
                  x1="936"
                  y1="623.2"
                  x2="951"
                  y2="597.3"/>
                <line
                  className="st1"
                  x1="951"
                  y1="597.3"
                  x2="936"
                  y2="571.3"/>
                <line
                  className="st1"
                  x1="936"
                  y1="623.2"
                  x2="906"
                  y2="623.2"/>
                <line
                  className="st1"
                  x1="891"
                  y1="597.3"
                  x2="906"
                  y2="623.2"/>
              </g>
              <line
                className="st1"
                x1="911"
                y1="616.2"
                x2="931"
                y2="616.2"/>
              <line
                className="st1"
                x1="932.4"
                y1="579.1"
                x2="942.4"
                y2="596.4"/>
              <g>
                <line
                  className="st1"
                  x1="868.5"
                  y1="532.3"
                  x2="876"
                  y2="519.3"/>
                <line
                  className="st1"
                  x1="876"
                  y1="519.3"
                  x2="891"
                  y2="519.3"/>
                <line
                  className="st1"
                  x1="891"
                  y1="545.3"
                  x2="898.5"
                  y2="532.3"/>
                <line
                  className="st1"
                  x1="898.5"
                  y1="532.3"
                  x2="891"
                  y2="519.3"/>
                <line
                  className="st1"
                  x1="891"
                  y1="545.3"
                  x2="876"
                  y2="545.3"/>
                <line
                  className="st1"
                  x1="868.5"
                  y1="532.3"
                  x2="876"
                  y2="545.3"/>
              </g>
              <line
                className="st1"
                x1="891"
                y1="545.3"
                x2="906"
                y2="571.3"/>
              <line
                className="st1"
                x1="887.7"
                y1="553.1"
                x2="897.7"
                y2="570.4"/>
              <line
                className="st1"
                x1="890.2"
                y1="649.2"
                x2="905.2"
                y2="623.2"/>
              <line
                className="st1"
                x1="951"
                y1="597.3"
                x2="971"
                y2="597.3"/>
              <g>
                <line
                  className="st1"
                  x1="1160.3"
                  y1="308"
                  x2="1160.3"
                  y2="338"/>
                <line
                  className="st1"
                  x1="1160.3"
                  y1="338"
                  x2="1134.3"
                  y2="353"/>
                <line
                  className="st1"
                  x1="1108.4"
                  y1="308"
                  x2="1108.4"
                  y2="338"/>
                <line
                  className="st1"
                  x1="1108.4"
                  y1="338"
                  x2="1134.3"
                  y2="353"/>
                <line
                  className="st1"
                  x1="1108.4"
                  y1="308"
                  x2="1134.3"
                  y2="293"/>
                <line
                  className="st1"
                  x1="1160.3"
                  y1="308"
                  x2="1134.3"
                  y2="293"/>
              </g>
              <line
                className="st1"
                x1="1153.3"
                y1="313"
                x2="1153.3"
                y2="333"/>
              <line
                className="st1"
                x1="1133.5"
                y1="344.4"
                x2="1116.2"
                y2="334.4"/>
              <line
                className="st1"
                x1="1108.4"
                y1="308.7"
                x2="1082.4"
                y2="293.7"/>
              <circle
                className="st2"
                cx="1082.4"
                cy="293.7"
                r="7"/>
              <g>
                <line
                  className="st1"
                  x1="1214.8"
                  y1="308"
                  x2="1214.8"
                  y2="338"/>
                <line
                  className="st1"
                  x1="1214.8"
                  y1="338"
                  x2="1188.8"
                  y2="353"/>
                <line
                  className="st1"
                  x1="1162.8"
                  y1="308"
                  x2="1162.8"
                  y2="338"/>
                <line
                  className="st1"
                  x1="1162.8"
                  y1="338"
                  x2="1188.8"
                  y2="353"/>
                <line
                  className="st1"
                  x1="1162.8"
                  y1="308"
                  x2="1188.8"
                  y2="293"/>
                <line
                  className="st1"
                  x1="1214.8"
                  y1="308"
                  x2="1188.8"
                  y2="293"/>
              </g>
              <line
                className="st1"
                x1="1188"
                y1="301.5"
                x2="1170.7"
                y2="311.5"/>
              <g>
                <line
                  className="st1"
                  x1="405.2"
                  y1="435.5"
                  x2="405.2"
                  y2="465.5"/>
                <line
                  className="st1"
                  x1="405.2"
                  y1="465.5"
                  x2="379.2"
                  y2="480.5"/>
                <line
                  className="st1"
                  x1="353.2"
                  y1="435.5"
                  x2="353.2"
                  y2="465.5"/>
                <line
                  className="st1"
                  x1="353.2"
                  y1="465.5"
                  x2="379.2"
                  y2="480.5"/>
                <line
                  className="st1"
                  x1="353.2"
                  y1="435.5"
                  x2="379.2"
                  y2="420.5"/>
                <line
                  className="st1"
                  x1="405.2"
                  y1="435.5"
                  x2="379.2"
                  y2="420.5"/>
              </g>
              <line
                className="st1"
                x1="378.4"
                y1="429"
                x2="361"
                y2="439"/>
              <line
                className="st1"
                x1="1214.8"
                y1="348"
                x2="1197.5"
                y2="358"/>
              <line
                className="st1"
                x1="677.4"
                y1="259.5"
                x2="703.4"
                y2="244.5"/>
              <line
                className="st1"
                x1="703.4"
                y1="216.1"
                x2="703.4"
                y2="246.1"/>
              <line
                className="st1"
                x1="703.4"
                y1="216.1"
                x2="729.3"
                y2="201.1"/>
              <line
                className="st1"
                x1="703.4"
                y1="216.1"
                x2="677.4"
                y2="201.1"/>
              <circle
                className="st2"
                cx="703.4"
                cy="246.1"
                r="7"/>
              <circle
                className="st2"
                cx="729.3"
                cy="201.1"
                r="7"/>
              <line
                className="st1"
                x1="694"
                y1="218.6"
                x2="676.7"
                y2="208.6"/>
              <line
                className="st1"
                x1="630"
                y1="323.4"
                x2="660"
                y2="271.5"/>
              <line
                className="st1"
                x1="630"
                y1="323.4"
                x2="570"
                y2="323.4"/>
              <circle
                className="st2"
                cx="630"
                cy="323.4"
                r="21"/>
              <circle
                className="st2"
                cx="570"
                cy="323.4"
                r="7"/>
              <ellipse
                transform="matrix(0.5 -0.866 0.866 0.5 92.7961 706.687)"
                className="st2"
                cx="658.4"
                cy="273"
                rx="21"
                ry="21"/>
              <circle
                className="st2"
                cx="466.1"
                cy="231.5"
                r="7"/>
              <circle
                className="st2"
                cx="1049.4"
                cy="201.1"
                r="7"/>
              <circle
                className="st2"
                cx="637.4"
                cy="543"
                r="7"/>
              <line
                className="st1"
                x1="458"
                y1="554.6"
                x2="440.6"
                y2="564.6"/>
              <line
                className="st1"
                x1="824.6"
                y1="281.7"
                x2="807.3"
                y2="291.7"/>
              <line
                className="st1"
                x1="1136"
                y1="405.5"
                x2="1118.7"
                y2="415.5"/>
              <line
                className="st1"
                x1="1025.2"
                y1="554.6"
                x2="1007.9"
                y2="564.6"/>
              <line
                className="st1"
                x1="561.8"
                y1="392.1"
                x2="544.5"
                y2="382.1"/>
              <line
                className="st1"
                x1="819.8"
                y1="621.2"
                x2="802.5"
                y2="611.2"/>
              <line
                className="st1"
                x1="1169"
                y1="382.1"
                x2="1151.7"
                y2="372.1"/>
              <line
                className="st1"
                x1="809"
                y1="163"
                x2="791.7"
                y2="153"/>
              <g>
                <line
                  className="st1"
                  x1="824.6"
                  y1="194.1"
                  x2="828.3"
                  y2="187.6"/>
                <line
                  className="st1"
                  x1="828.3"
                  y1="187.6"
                  x2="835.8"
                  y2="187.6"/>
                <line
                  className="st1"
                  x1="835.8"
                  y1="200.6"
                  x2="839.6"
                  y2="194.1"/>
                <line
                  className="st1"
                  x1="839.6"
                  y1="194.1"
                  x2="835.8"
                  y2="187.6"/>
                <line
                  className="st1"
                  x1="835.8"
                  y1="200.6"
                  x2="828.3"
                  y2="200.6"/>
                <line
                  className="st1"
                  x1="824.6"
                  y1="194.1"
                  x2="828.3"
                  y2="200.6"/>
              </g>
              <g>
                <line
                  className="st1"
                  x1="535.5"
                  y1="641"
                  x2="539.2"
                  y2="634.5"/>
                <line
                  className="st1"
                  x1="539.2"
                  y1="634.5"
                  x2="546.8"
                  y2="634.5"/>
                <line
                  className="st1"
                  x1="546.8"
                  y1="647.5"
                  x2="550.5"
                  y2="641"/>
                <line
                  className="st1"
                  x1="550.5"
                  y1="641"
                  x2="546.8"
                  y2="634.5"/>
                <line
                  className="st1"
                  x1="546.8"
                  y1="647.5"
                  x2="539.2"
                  y2="647.5"/>
                <line
                  className="st1"
                  x1="535.5"
                  y1="641"
                  x2="539.2"
                  y2="647.5"/>
              </g>
              <g>
                <line
                  className="st1"
                  x1="1214.8"
                  y1="450.5"
                  x2="1218.5"
                  y2="444"/>
                <line
                  className="st1"
                  x1="1218.5"
                  y1="444"
                  x2="1226"
                  y2="444"/>
                <line
                  className="st1"
                  x1="1226"
                  y1="457"
                  x2="1229.8"
                  y2="450.5"/>
                <line
                  className="st1"
                  x1="1229.8"
                  y1="450.5"
                  x2="1226"
                  y2="444"/>
                <line
                  className="st1"
                  x1="1226"
                  y1="457"
                  x2="1218.5"
                  y2="457"/>
                <line
                  className="st1"
                  x1="1214.8"
                  y1="450.5"
                  x2="1218.5"
                  y2="457"/>
              </g>
              <g>
                <line
                  className="st1"
                  x1="1080.9"
                  y1="637.7"
                  x2="1084.6"
                  y2="631.2"/>
                <line
                  className="st1"
                  x1="1084.6"
                  y1="631.2"
                  x2="1092.1"
                  y2="631.2"/>
                <line
                  className="st1"
                  x1="1092.1"
                  y1="644.2"
                  x2="1095.9"
                  y2="637.7"/>
                <line
                  className="st1"
                  x1="1095.9"
                  y1="637.7"
                  x2="1092.1"
                  y2="631.2"/>
                <line
                  className="st1"
                  x1="1092.1"
                  y1="644.2"
                  x2="1084.6"
                  y2="644.2"/>
                <line
                  className="st1"
                  x1="1080.9"
                  y1="637.7"
                  x2="1084.6"
                  y2="644.2"/>
              </g>
              <line
                className="st1"
                x1="344.5"
                y1="353"
                x2="344.5"
                y2="373"/>
              <line
                className="st1"
                x1="997.4"
                y1="661.9"
                x2="997.4"
                y2="681.9"/>
              <line
                className="st1"
                x1="1128.7"
                y1="192.5"
                x2="1076.7"
                y2="222.5"/>
              <ellipse
                transform="matrix(0.5 -0.866 0.866 0.5 397.5934 1073.7271)"
                className="st2"
                cx="1128.7"
                cy="192.5"
                rx="21"
                ry="21"/>
              <ellipse
                transform="matrix(0.5 -0.866 0.866 0.5 344.1906 1043.7056)"
                className="st2"
                cx="1076"
                cy="223.8"
                rx="7"
                ry="7"/>
              <g>
                <line
                  className="st1"
                  x1="1214.1"
                  y1="525.3"
                  x2="1214.1"
                  y2="495.3"/>
                <line
                  className="st1"
                  x1="1214.1"
                  y1="495.3"
                  x2="1240.1"
                  y2="480.3"/>
                <line
                  className="st1"
                  x1="1266.1"
                  y1="525.3"
                  x2="1266.1"
                  y2="495.3"/>
                <line
                  className="st1"
                  x1="1266.1"
                  y1="495.3"
                  x2="1240.1"
                  y2="480.3"/>
                <line
                  className="st1"
                  x1="1266.1"
                  y1="525.3"
                  x2="1240.1"
                  y2="540.3"/>
                <line
                  className="st1"
                  x1="1214.1"
                  y1="525.3"
                  x2="1240.1"
                  y2="540.3"/>
              </g>
              <line
                className="st1"
                x1="1265.3"
                y1="496"
                x2="1282.6"
                y2="486"/>
              <g>
                <line
                  className="st1"
                  x1="1144.9"
                  y1="566.1"
                  x2="1144.9"
                  y2="536.1"/>
                <line
                  className="st1"
                  x1="1144.9"
                  y1="536.1"
                  x2="1170.8"
                  y2="521.1"/>
                <line
                  className="st1"
                  x1="1196.8"
                  y1="566.1"
                  x2="1196.8"
                  y2="536.1"/>
                <line
                  className="st1"
                  x1="1196.8"
                  y1="536.1"
                  x2="1170.8"
                  y2="521.1"/>
                <line
                  className="st1"
                  x1="1196.8"
                  y1="566.1"
                  x2="1170.8"
                  y2="581.1"/>
                <line
                  className="st1"
                  x1="1144.9"
                  y1="566.1"
                  x2="1170.8"
                  y2="581.1"/>
              </g>
              <line
                className="st1"
                x1="1171.7"
                y1="572.5"
                x2="1189"
                y2="562.5"/>
              <line
                className="st1"
                x1="1197.1"
                y1="645.9"
                x2="1197.1"
                y2="625.9"/>
              <line
                className="st1"
                x1="1223.1"
                y1="612.1"
                x2="1249.1"
                y2="627.1"/>
              <line
                className="st1"
                x1="907.1"
                y1="474"
                x2="889.8"
                y2="464"/>
              <line
                className="st1"
                x1="1196.8"
                y1="536.1"
                x2="1214.1"
                y2="526.1"/>
              <g>
                <line
                  className="st1"
                  x1="1144.9"
                  y1="566.1"
                  x2="1144.9"
                  y2="536.1"/>
                <line
                  className="st1"
                  x1="1144.9"
                  y1="536.1"
                  x2="1170.8"
                  y2="521.1"/>
                <line
                  className="st1"
                  x1="1196.8"
                  y1="566.1"
                  x2="1196.8"
                  y2="536.1"/>
                <line
                  className="st1"
                  x1="1196.8"
                  y1="536.1"
                  x2="1170.8"
                  y2="521.1"/>
                <line
                  className="st1"
                  x1="1196.8"
                  y1="566.1"
                  x2="1170.8"
                  y2="581.1"/>
                <line
                  className="st1"
                  x1="1144.9"
                  y1="566.1"
                  x2="1170.8"
                  y2="581.1"/>
              </g>
              <g>
                <line
                  className="st1"
                  x1="1171.2"
                  y1="612.1"
                  x2="1171.2"
                  y2="582.1"/>
                <line
                  className="st1"
                  x1="1171.2"
                  y1="582.1"
                  x2="1197.1"
                  y2="567.1"/>
                <line
                  className="st1"
                  x1="1223.1"
                  y1="612.1"
                  x2="1223.1"
                  y2="582.1"/>
                <line
                  className="st1"
                  x1="1223.1"
                  y1="582.1"
                  x2="1197.1"
                  y2="567.1"/>
                <line
                  className="st1"
                  x1="1223.1"
                  y1="612.1"
                  x2="1197.1"
                  y2="627.1"/>
                <line
                  className="st1"
                  x1="1171.2"
                  y1="612.1"
                  x2="1197.1"
                  y2="627.1"/>
              </g>
              <g>
                <line
                  className="st1"
                  x1="1210.1"
                  y1="667.8"
                  x2="1197.1"
                  y2="675.3"/>
                <line
                  className="st1"
                  x1="1197.1"
                  y1="675.3"
                  x2="1184.2"
                  y2="667.8"/>
                <line
                  className="st1"
                  x1="1197.1"
                  y1="645.3"
                  x2="1184.2"
                  y2="652.8"/>
                <line
                  className="st1"
                  x1="1184.2"
                  y1="652.8"
                  x2="1184.2"
                  y2="667.8"/>
                <line
                  className="st1"
                  x1="1197.1"
                  y1="645.3"
                  x2="1210.1"
                  y2="652.8"/>
                <line
                  className="st1"
                  x1="1210.1"
                  y1="667.8"
                  x2="1210.1"
                  y2="652.8"/>
              </g>
              <line
                className="st1"
                x1="396.3"
                y1="288.5"
                x2="369.6"
                y2="274.7"/>

              <ellipse
                transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -12.9803 18.7979)"
                className="st2"
                cx="397.7"
                cy="288.5"
                rx="7"
                ry="7"/>
              <line
                className="st1"
                x1="350.4"
                y1="192.2"
                x2="350.4"
                y2="266.2"/>
              <line
                className="st1"
                x1="350.4"
                y1="266.2"
                x2="271.5"
                y2="311.8"/>
              <line
                className="st1"
                x1="350.4"
                y1="265.5"
                x2="417.6"
                y2="226.7"/>
              <circle
                className="st2"
                cx="350.4"
                cy="266.2"
                r="21"/>

              <ellipse
                transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -14.1998 12.957)"
                className="st2"
                cx="271.5"
                cy="311.8"
                rx="7"
                ry="7"/>

              <ellipse
                transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -8.5553 16.4951)"
                className="st2"
                cx="350.4"
                cy="192.2"
                rx="7"
                ry="7"/>

              <ellipse
                transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -10.0862 19.6561)"
                className="st2"
                cx="417.6"
                cy="226.7"
                rx="7"
                ry="7"/>
              <g>
                <line
                  className="st1"
                  x1="483.9"
                  y1="616.2"
                  x2="483.9"
                  y2="646.2"/>
                <line
                  className="st1"
                  x1="483.9"
                  y1="646.2"
                  x2="458"
                  y2="661.2"/>
                <line
                  className="st1"
                  x1="432"
                  y1="616.2"
                  x2="432"
                  y2="646.2"/>
                <line
                  className="st1"
                  x1="432"
                  y1="646.2"
                  x2="458"
                  y2="661.2"/>
                <line
                  className="st1"
                  x1="432"
                  y1="616.2"
                  x2="458"
                  y2="601.2"/>
                <line
                  className="st1"
                  x1="483.9"
                  y1="616.2"
                  x2="458"
                  y2="601.2"/>
              </g>
              <line
                className="st1"
                x1="457.5"
                y1="661.1"
                x2="457.5"
                y2="681.1"/>
              <line
                className="st1"
                x1="476.1"
                y1="619.8"
                x2="458.8"
                y2="609.8"/>
              <line
                className="st1"
                x1="483.5"
                y1="696"
                x2="483.5"
                y2="726"/>
              <line
                className="st1"
                x1="431.5"
                y1="696"
                x2="431.5"
                y2="726"/>
              <line
                className="st1"
                x1="431.5"
                y1="726"
                x2="457.5"
                y2="741"/>
              <line
                className="st1"
                x1="431.5"
                y1="696"
                x2="457.5"
                y2="681"/>
              <line
                className="st1"
                x1="483.5"
                y1="696"
                x2="457.5"
                y2="681"/>
              <g>
                <line
                  className="st1"
                  x1="406"
                  y1="573"
                  x2="406"
                  y2="603"/>
                <line
                  className="st1"
                  x1="406"
                  y1="603"
                  x2="380"
                  y2="618"/>
                <line
                  className="st1"
                  x1="354"
                  y1="573"
                  x2="354"
                  y2="603"/>
                <line
                  className="st1"
                  x1="354"
                  y1="603"
                  x2="380"
                  y2="618"/>
                <line
                  className="st1"
                  x1="354"
                  y1="573"
                  x2="380"
                  y2="558"/>
                <line
                  className="st1"
                  x1="406"
                  y1="573"
                  x2="380"
                  y2="558"/>
              </g>
              <line
                className="st1"
                x1="399"
                y1="578"
                x2="399"
                y2="598"/>
              <line
                className="st1"
                x1="432.3"
                y1="616.7"
                x2="405.7"
                y2="602.9"/>
              <line
                className="st1"
                x1="380"
                y1="619.5"
                x2="380"
                y2="649.5"/>
              <line
                className="st1"
                x1="373.6"
                y1="624.5"
                x2="373.6"
                y2="644.5"/>
            </g>
            <g className="st3">
              <line
                className="st1"
                x1="378.4"
                y1="429"
                x2="361"
                y2="439"/>
              <line
                className="st1"
                x1="353.2"
                y1="465.5"
                x2="335.9"
                y2="475.5"/>
              <circle
                className="st2"
                cx="576"
                cy="513"
                r="7"/>
              <circle
                className="st2"
                cx="741.4"
                cy="566.6"
                r="7"/>
              <circle
                className="st2"
                cx="651.4"
                cy="620"
                r="7"/>
              <line
                className="st1"
                x1="767.4"
                y1="686.1"
                x2="767.4"
                y2="716.1"/>
              <line
                className="st1"
                x1="767.4"
                y1="686.1"
                x2="793.3"
                y2="671.1"/>
              <circle
                className="st2"
                cx="767.4"
                cy="716.1"
                r="7"/>
              <circle
                className="st2"
                cx="793.3"
                cy="671.1"
                r="7"/>
              <ellipse
                transform="matrix(0.5 -0.866 0.866 0.5 104.8678 1060.3438)"
                className="st2"
                cx="970.7"
                cy="439.4"
                rx="7"
                ry="7"/>
              <ellipse
                transform="matrix(0.866 -0.5 0.5 0.866 -94.4257 615.5371)"
                className="st2"
                cx="1101.4"
                cy="484"
                rx="7"
                ry="7"/>
              <line
                className="st1"
                x1="976.4"
                y1="268"
                x2="993.7"
                y2="278"/>
              <line
                className="st1"
                x1="993.7"
                y1="278"
                x2="993.7"
                y2="308"/>
              <line
                className="st1"
                x1="986.7"
                y1="283"
                x2="986.7"
                y2="303"/>
              <g>
                <line
                  className="st1"
                  x1="868.5"
                  y1="532.3"
                  x2="876"
                  y2="519.3"/>
                <line
                  className="st1"
                  x1="876"
                  y1="519.3"
                  x2="891"
                  y2="519.3"/>
                <line
                  className="st1"
                  x1="891"
                  y1="545.3"
                  x2="898.5"
                  y2="532.3"/>
                <line
                  className="st1"
                  x1="898.5"
                  y1="532.3"
                  x2="891"
                  y2="519.3"/>
                <line
                  className="st1"
                  x1="891"
                  y1="545.3"
                  x2="876"
                  y2="545.3"/>
                <line
                  className="st1"
                  x1="868.5"
                  y1="532.3"
                  x2="876"
                  y2="545.3"/>
              </g>
              <line
                className="st1"
                x1="890.2"
                y1="649.2"
                x2="905.2"
                y2="623.2"/>
              <line
                className="st1"
                x1="1108.4"
                y1="308.7"
                x2="1082.4"
                y2="293.7"/>
              <circle
                className="st2"
                cx="1082.4"
                cy="293.7"
                r="7"/>
              <line
                className="st1"
                x1="1188"
                y1="301.5"
                x2="1170.7"
                y2="311.5"/>
              <line
                className="st1"
                x1="378.4"
                y1="429"
                x2="361"
                y2="439"/>
              <line
                className="st1"
                x1="677.4"
                y1="259.5"
                x2="703.4"
                y2="244.5"/>
              <circle
                className="st2"
                cx="703.4"
                cy="246.1"
                r="7"/>
              <circle
                className="st2"
                cx="637.4"
                cy="543"
                r="7"/>
              <g>
                <line
                  className="st1"
                  x1="824.6"
                  y1="194.1"
                  x2="828.3"
                  y2="187.6"/>
                <line
                  className="st1"
                  x1="828.3"
                  y1="187.6"
                  x2="835.8"
                  y2="187.6"/>
                <line
                  className="st1"
                  x1="835.8"
                  y1="200.6"
                  x2="839.6"
                  y2="194.1"/>
                <line
                  className="st1"
                  x1="839.6"
                  y1="194.1"
                  x2="835.8"
                  y2="187.6"/>
                <line
                  className="st1"
                  x1="835.8"
                  y1="200.6"
                  x2="828.3"
                  y2="200.6"/>
                <line
                  className="st1"
                  x1="824.6"
                  y1="194.1"
                  x2="828.3"
                  y2="200.6"/>
              </g>
              <line
                className="st1"
                x1="1265.3"
                y1="496"
                x2="1282.6"
                y2="486"/>
              <line
                className="st1"
                x1="1197.1"
                y1="645.9"
                x2="1197.1"
                y2="625.9"/>
              <line
                className="st1"
                x1="1223.1"
                y1="612.1"
                x2="1249.1"
                y2="627.1"/>
              <g>
                <line
                  className="st1"
                  x1="1210.1"
                  y1="667.8"
                  x2="1197.1"
                  y2="675.3"/>
                <line
                  className="st1"
                  x1="1197.1"
                  y1="675.3"
                  x2="1184.2"
                  y2="667.8"/>
                <line
                  className="st1"
                  x1="1197.1"
                  y1="645.3"
                  x2="1184.2"
                  y2="652.8"/>
                <line
                  className="st1"
                  x1="1184.2"
                  y1="652.8"
                  x2="1184.2"
                  y2="667.8"/>
                <line
                  className="st1"
                  x1="1197.1"
                  y1="645.3"
                  x2="1210.1"
                  y2="652.8"/>
                <line
                  className="st1"
                  x1="1210.1"
                  y1="667.8"
                  x2="1210.1"
                  y2="652.8"/>
              </g>

              <ellipse
                transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -8.5553 16.4951)"
                className="st4"
                cx="350.4"
                cy="192.2"
                rx="7"
                ry="7"/>
              <line
                className="st1"
                x1="457.5"
                y1="661.1"
                x2="457.5"
                y2="681.1"/>
              <line
                className="st1"
                x1="483.5"
                y1="696"
                x2="483.5"
                y2="726"/>
              <line
                className="st1"
                x1="431.5"
                y1="696"
                x2="431.5"
                y2="726"/>
              <line
                className="st1"
                x1="431.5"
                y1="726"
                x2="457.5"
                y2="741"/>
              <line
                className="st1"
                x1="431.5"
                y1="696"
                x2="457.5"
                y2="681"/>
              <line
                className="st1"
                x1="483.5"
                y1="696"
                x2="457.5"
                y2="681"/>
            </g>
          </g>
        </svg>
      </div>
      <div
        className="layer layer-2" data-depth="0.30"
      >
        <svg id="player-layer-2"
              width="1147"
              height="599"
              viewBox="0 0 1147 599">
          <g fill="#FFF"  opacity=".2">
            <path d="M561.64 592.83V596h-1.5v-8.53h3.28c.95 0 1.7.25 2.27.74.55.5.83 1.17.83 1.98 0 .84-.28 1.5-.82 1.95-.54.47-1.3.7-2.3.7h-1.76zm0-1.2h1.78c.52 0 .93-.1 1.2-.36.28-.25.42-.6.42-1.08 0-.47-.14-.84-.42-1.1-.28-.3-.67-.43-1.16-.44h-1.82v2.98zm6.7 1.14c0-.62.13-1.18.37-1.68.26-.5.6-.9 1.05-1.16.44-.26.96-.4 1.53-.4.86 0 1.55.28 2.1.83.52.55.8 1.28.85 2.2v.32c0 .62-.1 1.18-.35 1.67-.24.5-.6.87-1.03 1.14-.45.28-.97.42-1.55.42-.9 0-1.6-.3-2.15-.9-.54-.6-.8-1.4-.8-2.38v-.07zm1.43.12c0 .65.13 1.16.4 1.53.27.37.65.55 1.13.55.48 0 .85-.2 1.12-.56.27-.38.4-.93.4-1.65 0-.64-.14-1.15-.4-1.52-.3-.38-.66-.56-1.14-.56-.46 0-.83.17-1.1.54-.28.37-.4.92-.4 1.65zm10.23 1.38c0-.26-.1-.45-.32-.58-.2-.14-.55-.25-1.04-.35-.48-.1-.9-.23-1.2-.4-.72-.33-1.08-.83-1.08-1.5 0-.53.23-1 .7-1.36.45-.37 1.04-.56 1.75-.56.77 0 1.38.2 1.85.57.47.38.7.87.7 1.46h-1.43c0-.27-.1-.5-.3-.68-.2-.18-.47-.27-.8-.27-.32 0-.58.08-.77.23-.2.14-.3.33-.3.58 0 .23.1.4.28.52.18.12.55.24 1.1.36.57.13 1 .27 1.33.44.3.17.55.38.7.6.16.25.24.54.24.88 0 .57-.24 1.03-.7 1.4-.5.34-1.1.52-1.87.52-.52 0-.98-.1-1.4-.28-.4-.2-.7-.45-.94-.78s-.35-.68-.35-1.06h1.38c.02.34.15.6.4.78.22.18.53.27.92.27.37 0 .66-.07.85-.2.2-.16.3-.34.3-.57zm5.42-6.16v1.54h1.12v1.05h-1.12v3.55c0 .25.05.42.14.53.1.1.27.16.52.16.16 0 .33-.02.5-.06v1.1c-.33.1-.64.14-.94.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.05v-1.06H584v-1.54h1.42zm13.84 5.1c-.1.9-.42 1.62-1 2.13-.6.5-1.37.77-2.34.77-.68 0-1.28-.16-1.8-.5-.52-.3-.92-.77-1.2-1.36-.28-.6-.43-1.28-.44-2.07v-.8c0-.8.14-1.52.43-2.13.3-.62.7-1.1 1.24-1.42.53-.33 1.15-.5 1.85-.5.93 0 1.68.26 2.26.77.57.5.9 1.23 1 2.17h-1.48c-.07-.63-.24-1.07-.53-1.34-.3-.27-.7-.4-1.26-.4-.66 0-1.15.23-1.5.7-.35.47-.52 1.16-.53 2.07v.76c0 .9.16 1.6.5 2.1.32.48.8.72 1.45.72.58 0 1-.13 1.3-.4.3-.25.5-.7.56-1.3h1.48zm1.92-.45c0-.62.12-1.18.37-1.68s.6-.9 1.04-1.16c.43-.26.94-.4 1.52-.4.86 0 1.55.28 2.1.83.52.55.8 1.28.85 2.2v.32c0 .62-.1 1.18-.36 1.67-.23.5-.57.87-1.02 1.14-.44.28-.96.42-1.55.42-.9 0-1.6-.3-2.14-.9-.55-.6-.82-1.4-.82-2.38v-.07zm1.42.12c0 .65.14 1.16.4 1.53.28.37.65.55 1.13.55.48 0 .86-.2 1.13-.56.26-.38.4-.93.4-1.65 0-.64-.14-1.15-.42-1.52-.27-.38-.65-.56-1.12-.56-.46 0-.83.17-1.1.54-.28.37-.42.92-.42 1.65zm8.2 3.1h-1.43v-6.34h1.42V596zm-1.52-8c0-.2.07-.4.2-.53.15-.15.35-.22.6-.22.26 0 .46.07.6.22.14.14.2.32.2.54 0 .23-.06.4-.2.55-.14.14-.34.2-.6.2-.25 0-.45-.06-.6-.2-.13-.14-.2-.32-.2-.54zm5.85.12v1.54h1.12v1.05h-1.12v3.55c0 .25.05.42.14.53.1.1.27.16.5.16.18 0 .34-.02.5-.06v1.1c-.3.1-.62.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.04v-1.54h1.43zm7 7.88c-.07-.12-.13-.32-.17-.6-.46.48-1 .72-1.67.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.24-1.2.74-1.55.5-.36 1.22-.54 2.16-.54h.87v-.42c0-.32-.08-.58-.26-.78-.2-.2-.47-.3-.84-.3-.33 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.1-.68.34-1 .24-.3.56-.53.95-.7.4-.17.84-.26 1.33-.26.74 0 1.33.2 1.78.56.44.38.66.9.67 1.58v2.86c0 .57.1 1.02.25 1.36v.1h-1.46zm-1.57-1.03c.28 0 .54-.06.8-.2.24-.14.43-.32.55-.55v-1.2h-.76c-.52 0-.92.1-1.2.28-.25.18-.38.44-.38.78 0 .27.1.5.27.65.18.16.42.24.73.24zm6.78 1.03h-1.42v-9h1.42v9zm13.2-2.78c-.1.9-.44 1.62-1.02 2.13-.6.5-1.37.77-2.34.77-.68 0-1.28-.16-1.8-.5-.5-.3-.9-.77-1.2-1.36-.27-.6-.42-1.28-.43-2.07v-.8c0-.8.14-1.52.42-2.13.3-.62.7-1.1 1.23-1.42.54-.33 1.15-.5 1.85-.5.94 0 1.7.26 2.27.77.58.5.9 1.23 1 2.17h-1.47c-.07-.63-.25-1.07-.54-1.34-.27-.27-.7-.4-1.25-.4-.64 0-1.14.23-1.48.7-.35.47-.53 1.16-.53 2.07v.76c0 .9.16 1.6.5 2.1.32.48.8.72 1.44.72.58 0 1.02-.13 1.3-.4.3-.25.5-.7.57-1.3h1.48zm1.9-.45c0-.62.13-1.18.38-1.68.24-.5.6-.9 1.03-1.16.45-.26.96-.4 1.54-.4.84 0 1.54.28 2.07.83.53.55.82 1.28.86 2.2v.32c0 .62-.1 1.18-.35 1.67-.24.5-.58.87-1.03 1.14-.45.28-.96.42-1.55.42-.9 0-1.6-.3-2.15-.9-.54-.6-.8-1.4-.8-2.38v-.07zm1.43.12c0 .65.13 1.16.4 1.53.27.37.65.55 1.13.55.48 0 .85-.2 1.12-.56.27-.38.4-.93.4-1.65 0-.64-.13-1.15-.4-1.52-.3-.38-.66-.56-1.13-.56-.48 0-.85.17-1.12.54-.27.37-.4.92-.4 1.65zm8-3.24l.04.73c.48-.57 1.1-.86 1.85-.86 1.32 0 2 .76 2.02 2.27v4.2h-1.43v-4.1c0-.4-.08-.7-.26-.9-.17-.2-.45-.3-.85-.3-.57 0-1 .27-1.28.8v4.5h-1.43v-6.34h1.35zm8.13-1.54v1.54h1.12v1.05H660v3.55c0 .25.05.42.15.53.1.1.26.16.5.16.17 0 .34-.02.5-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.04v-1.54H660zm6.53 2.84c-.2-.03-.38-.05-.58-.05-.65 0-1.1.26-1.32.76V596h-1.42v-6.34h1.37l.03.7c.34-.54.82-.82 1.43-.82.2 0 .37.03.5.08v1.34zm5.5 5.04c-.05-.12-.1-.32-.15-.6-.46.48-1 .72-1.67.72-.62 0-1.14-.18-1.55-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.16-.54h.87v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.83-.3-.33 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.44c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.33-.26.74 0 1.33.2 1.77.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.46zm-1.55-1.03c.28 0 .54-.06.8-.2.24-.14.42-.32.55-.55v-1.2h-.77c-.53 0-.92.1-1.2.28-.25.18-.4.44-.4.78 0 .27.1.5.3.65.17.16.4.24.72.24zm7.87 0c.35 0 .65-.1.88-.3.24-.2.36-.46.38-.77h1.35c-.02.4-.14.77-.37 1.1-.23.35-.54.62-.94.82-.4.2-.82.3-1.27.3-.9 0-1.6-.3-2.1-.86-.53-.58-.8-1.37-.8-2.38v-.15c0-.96.27-1.74.78-2.32.52-.57 1.22-.86 2.1-.86.76 0 1.38.22 1.85.66.48.44.73 1.02.75 1.73h-1.34c0-.36-.13-.66-.36-.9-.24-.23-.53-.34-.9-.34-.45 0-.8.15-1.06.5-.25.32-.37.83-.38 1.5v.24c0 .68.13 1.2.37 1.53.25.34.6.5 1.08.5zm7.47 1.15c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.12-1.2.37-1.7.24-.5.6-.88 1.03-1.16.44-.28.93-.42 1.47-.42.87 0 1.53.28 2 .83.48.55.7 1.33.7 2.34v.58h-4.13c.04.52.22.94.52 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.25.38-.6.67-1.02.88-.42.2-.9.32-1.42.32zm-.17-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.14-.84-.37-1.1-.22-.23-.53-.35-.92-.35zm10.37 2.2c0 .98-.23 1.76-.67 2.34-.45.6-1.04.88-1.8.88-.7 0-1.25-.23-1.66-.7v3.02h-1.44v-8.78h1.3l.07.64c.42-.5 1-.76 1.7-.76.78 0 1.4.3 1.83.87.44.58.66 1.38.66 2.4v.1zm-1.42-.13c0-.63-.13-1.13-.38-1.5-.25-.38-.6-.56-1.08-.56-.58 0-1 .25-1.25.73v2.8c.24.5.67.75 1.25.75.45 0 .8-.18 1.06-.55.27-.36.4-.92.4-1.66zm5.4-4.65v1.54h1.12v1.05H700v3.55c0 .25.05.42.15.53.1.1.27.16.5.16.18 0 .34-.02.5-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.04v-1.54H700zm4.73 7.88h-1.43v-6.34h1.43V596zm-1.52-8c0-.2.08-.4.22-.53.14-.15.34-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.26 0-.46-.06-.6-.2-.14-.14-.2-.32-.2-.54zm3.8 4.77c0-.62.13-1.18.38-1.68.24-.5.6-.9 1.04-1.16.44-.26.95-.4 1.53-.4.86 0 1.55.28 2.08.83.54.55.82 1.28.87 2.2v.32c0 .62-.12 1.18-.36 1.67-.24.5-.58.87-1.03 1.14-.44.28-.95.42-1.54.42-.9 0-1.6-.3-2.15-.9-.52-.6-.8-1.4-.8-2.38v-.07zm1.43.12c0 .65.14 1.16.4 1.53.28.37.65.55 1.13.55.48 0 .86-.2 1.12-.56.27-.38.4-.93.4-1.65 0-.64-.13-1.15-.4-1.52-.28-.38-.66-.56-1.13-.56-.46 0-.83.17-1.1.54-.28.37-.42.92-.42 1.65zm8-3.24l.04.73c.47-.57 1.08-.86 1.85-.86 1.32 0 2 .76 2 2.27v4.2h-1.4v-4.1c0-.4-.1-.7-.27-.9-.18-.2-.46-.3-.86-.3-.58 0-1 .27-1.3.8v4.5h-1.4v-6.34h1.33zM388.7 494.9c-.32.4-.75.7-1.3.9-.54.2-1.16.32-1.86.32-.7 0-1.35-.16-1.9-.5-.55-.3-.97-.78-1.27-1.38-.3-.6-.46-1.3-.47-2.1v-.68c0-1.3.3-2.3.93-3.02.6-.73 1.48-1.1 2.58-1.1.96 0 1.7.25 2.27.7.56.48.9 1.16 1 2.04h-1.44c-.17-1.03-.76-1.54-1.8-1.54-.65 0-1.16.24-1.5.72-.35.48-.53 1.18-.54 2.1v.66c0 .92.18 1.64.57 2.15.4.5.93.76 1.62.76.75 0 1.3-.17 1.6-.5v-1.68h-1.75v-1.13h3.24v3.27zm4 1.1h-1.43v-9h1.42v9zm6.33 0c-.06-.12-.12-.32-.16-.6-.46.48-1 .72-1.67.72-.63 0-1.15-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.2-.54 2.15-.54h.87v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.83-.3-.32 0-.58.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.33-.26.73 0 1.32.2 1.76.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.56-1.03c.28 0 .54-.06.8-.2.24-.14.42-.32.55-.55v-1.2h-.77c-.53 0-.92.1-1.2.28-.25.18-.4.44-.4.78 0 .27.1.5.3.65.17.16.4.24.72.24zm9.1.4c-.4.5-1 .75-1.78.75-.7 0-1.2-.2-1.57-.6-.35-.4-.53-1-.53-1.75v-4.1h1.43v4.08c0 .8.33 1.2 1 1.2.7 0 1.16-.24 1.4-.74v-4.54h1.42V496h-1.34l-.02-.62zm6.44-.4c.36 0 .66-.1.9-.3.23-.2.35-.46.37-.77h1.34c0 .4-.13.77-.36 1.1-.23.35-.54.62-.94.82-.4.2-.82.3-1.28.3-.88 0-1.6-.3-2.1-.86-.52-.58-.78-1.37-.78-2.38v-.15c0-.96.25-1.74.77-2.32.52-.57 1.23-.86 2.12-.86.75 0 1.37.22 1.84.66.48.44.72 1.02.75 1.73h-1.33c-.02-.36-.14-.66-.38-.9-.24-.23-.53-.34-.9-.34-.45 0-.8.15-1.06.5-.25.32-.38.83-.38 1.5v.24c0 .68.12 1.2.37 1.53.25.34.6.5 1.08.5zm4.42-2.2c0-.62.12-1.18.37-1.68.23-.5.58-.9 1.02-1.16.45-.26.96-.4 1.54-.4.85 0 1.55.28 2.08.83.53.55.82 1.28.87 2.2v.32c0 .62-.1 1.18-.35 1.67-.24.5-.58.87-1.03 1.14-.45.28-.96.42-1.55.42-.9 0-1.6-.3-2.15-.9-.53-.6-.8-1.4-.8-2.38v-.07zm1.42.12c0 .65.14 1.16.4 1.53.27.37.65.55 1.13.55.48 0 .85-.2 1.12-.56.26-.38.4-.93.4-1.65 0-.64-.14-1.15-.42-1.52-.27-.38-.65-.56-1.12-.56-.47 0-.84.17-1.1.54-.28.37-.42.92-.42 1.65zm8-3.24l.06.66c.44-.52 1.05-.78 1.82-.78.85 0 1.43.33 1.74.98.46-.65 1.1-.98 1.95-.98.7 0 1.23.2 1.57.58.34.4.52.96.53 1.7V496h-1.43v-4.13c0-.4-.1-.7-.26-.88-.17-.2-.46-.3-.87-.3-.32 0-.58.1-.8.27-.2.17-.34.4-.42.68l.02 4.35h-1.43v-4.17c-.03-.75-.4-1.12-1.15-1.12-.57 0-.98.24-1.2.7v4.6h-1.44v-6.34h1.35zm13.9 6.34c-.06-.12-.1-.32-.16-.6-.45.48-1 .72-1.66.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.23-.54 2.16-.54h.87v-.42c0-.32-.1-.58-.27-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.1-.68.34-1 .23-.3.54-.53.94-.7.4-.17.83-.26 1.32-.26.75 0 1.34.2 1.78.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.56-1.03c.28 0 .55-.06.8-.2.24-.14.43-.32.55-.55v-1.2h-.76c-.53 0-.93.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.18.16.43.24.73.24zM857.53 537h-1.47v-8.53h1.47V537zm2.83 0v-8.53h2.92c.96 0 1.7.2 2.2.58.5.4.76.96.76 1.73 0 .4-.1.74-.32 1.05-.2.3-.52.56-.92.73.46.12.8.36 1.07.7.25.35.37.77.37 1.25 0 .8-.25 1.43-.77 1.86-.5.43-1.25.64-2.2.64h-3.1zm1.48-3.85v2.67h1.64c.47 0 .83-.12 1.1-.35.26-.23.4-.55.4-.96 0-.88-.47-1.33-1.37-1.35h-1.76zm0-1.1h1.45c.45 0 .8-.1 1.07-.3.26-.2.4-.5.4-.9s-.13-.72-.37-.9c-.24-.2-.6-.3-1.12-.3h-1.44v2.4zm7.1 4.95v-8.53h2.5c.76 0 1.43.17 2 .5.6.34 1.05.82 1.37 1.43.33.62.5 1.33.5 2.12v.43c0 .8-.17 1.52-.5 2.13-.32.62-.78 1.1-1.37 1.42-.6.33-1.28.5-2.05.5h-2.45zm1.47-7.34v6.16h.97c.78 0 1.38-.25 1.8-.73.4-.5.62-1.2.63-2.1v-.48c0-.93-.2-1.64-.6-2.12-.4-.5-1-.74-1.75-.74h-1.04zM902.72 157h-1.47v-8.53h1.47V157zm4-6.34l.05.73c.47-.57 1.08-.86 1.85-.86 1.32 0 2 .76 2 2.27v4.2h-1.4v-4.1c0-.4-.1-.7-.27-.9-.18-.2-.46-.3-.86-.3-.58 0-1 .27-1.3.8v4.5h-1.4v-6.34h1.33zm6.86 6.34v-5.3h-.96v-1.04h.96v-.58c0-.7.2-1.25.6-1.63.38-.38.93-.57 1.63-.57.26 0 .52.03.8.1l-.03 1.12c-.16-.04-.34-.05-.54-.05-.68 0-1.02.35-1.02 1.05v.56h1.3v1.05H915v5.3h-1.42zm6.27 0h-1.42v-9h1.42v9zm6.34 0c-.07-.12-.13-.32-.18-.6-.45.48-1 .72-1.66.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.88v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.33-.26.74 0 1.33.2 1.77.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.58-1.03c.28 0 .55-.06.8-.2s.43-.32.56-.55v-1.2h-.77c-.52 0-.9.1-1.18.28-.27.18-.4.44-.4.78 0 .27.1.5.27.65.18.16.42.24.72.24zm6.6-5.3l.05.65c.45-.52 1.06-.78 1.83-.78.85 0 1.43.33 1.74.98.46-.65 1.1-.98 1.95-.98.68 0 1.2.2 1.55.58.34.4.5.96.52 1.7V157h-1.42v-4.13c0-.4-.1-.7-.27-.88-.17-.2-.46-.3-.87-.3-.3 0-.58.1-.78.27-.2.17-.35.4-.43.68V157h-1.43v-4.17c-.02-.75-.4-1.12-1.14-1.12-.57 0-.98.24-1.22.7v4.6h-1.4v-6.34h1.33zm11.45 0l.04.65c.46-.52 1.07-.78 1.84-.78.85 0 1.43.33 1.74.98.46-.65 1.1-.98 1.95-.98.7 0 1.22.2 1.56.58.33.4.5.96.5 1.7V157h-1.4v-4.13c0-.4-.1-.7-.27-.88-.18-.2-.47-.3-.88-.3-.32 0-.6.1-.8.27-.2.17-.34.4-.42.68V157h-1.42v-4.17c0-.75-.4-1.12-1.13-1.12-.57 0-.98.24-1.22.7v4.6h-1.42v-6.34h1.34zm13.9 6.33c-.07-.12-.12-.32-.17-.6-.45.48-1 .72-1.67.72-.63 0-1.15-.18-1.55-.55-.4-.36-.6-.8-.6-1.35 0-.67.24-1.2.75-1.55.5-.36 1.2-.54 2.15-.54h.87v-.42c0-.32-.1-.58-.27-.78-.2-.2-.47-.3-.84-.3-.33 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.12-.68.35-1 .23-.3.55-.53.94-.7.4-.17.83-.26 1.32-.26.74 0 1.33.2 1.78.56.44.38.66.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.46zm-1.57-1.03c.28 0 .54-.06.8-.2.24-.14.43-.32.55-.55v-1.2h-.77c-.52 0-.92.1-1.2.28-.25.18-.38.44-.38.78 0 .27.1.5.27.65.18.16.42.24.73.24zm7.05-6.85v1.54h1.12v1.05h-1.12v3.55c0 .25.05.42.14.53.1.1.26.16.5.16.17 0 .34-.02.5-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.05v-1.06h1.05v-1.54h1.42zm2.76 4.65c0-.62.14-1.18.38-1.68.25-.5.6-.9 1.04-1.16.45-.26.96-.4 1.54-.4.85 0 1.55.28 2.08.83.53.55.82 1.28.86 2.2v.32c0 .62-.1 1.18-.35 1.67-.24.5-.6.87-1.03 1.14-.45.28-.97.42-1.55.42-.9 0-1.6-.3-2.15-.9-.54-.6-.8-1.4-.8-2.38v-.07zm1.44.12c0 .65.13 1.16.4 1.53.27.37.65.55 1.13.55.48 0 .85-.2 1.12-.56.26-.38.4-.93.4-1.65 0-.64-.15-1.15-.42-1.52-.28-.38-.65-.56-1.12-.56-.47 0-.84.17-1.1.54-.3.37-.42.92-.42 1.65zm10-1.94c-.2-.03-.4-.05-.6-.05-.64 0-1.08.26-1.3.76V157h-1.43v-6.34h1.37l.03.7c.35-.54.82-.82 1.43-.82.2 0 .38.03.5.1v1.32zm4.22 3l1.28-4.3h1.52l-2.52 7.3c-.38 1.07-1.04 1.6-1.97 1.6-.2 0-.43-.03-.68-.1v-1.1h.26c.36 0 .63-.05.8-.2.2-.12.33-.34.44-.64l.2-.55-2.22-6.3h1.53l1.36 4.3zm8.75 2.04v-8.53h2.93c.96 0 1.7.2 2.2.58.5.4.76.96.76 1.73 0 .4-.12.74-.33 1.05-.2.3-.52.56-.92.73.46.12.8.36 1.07.7.25.35.37.77.37 1.25 0 .8-.26 1.43-.78 1.86-.5.43-1.25.64-2.2.64h-3.1zm1.5-3.85v2.67h1.63c.47 0 .83-.12 1.1-.35.26-.23.4-.55.4-.96 0-.88-.47-1.33-1.37-1.35h-1.77zm0-1.1h1.44c.46 0 .82-.1 1.08-.3.26-.2.4-.5.4-.9s-.13-.72-.37-.9c-.24-.2-.6-.3-1.12-.3h-1.44v2.4zm6.67 1.72c0-.62.12-1.18.37-1.68s.6-.9 1.04-1.16c.44-.26.95-.4 1.53-.4.87 0 1.56.28 2.1.83.53.55.82 1.28.86 2.2v.32c0 .62-.1 1.18-.35 1.67-.23.5-.58.87-1.03 1.14-.44.28-.96.42-1.55.42-.9 0-1.6-.3-2.14-.9-.54-.6-.8-1.4-.8-2.38v-.07zm1.42.12c0 .65.13 1.16.4 1.53.27.37.64.55 1.12.55.48 0 .86-.2 1.13-.56.26-.38.4-.93.4-1.65 0-.64-.14-1.15-.42-1.52-.27-.38-.64-.56-1.12-.56-.45 0-.82.17-1.1.54-.27.37-.4.92-.4 1.65zm12.24 1.14l1-4.38h1.4l-1.73 6.34h-1.16l-1.36-4.35-1.34 4.35h-1.17l-1.74-6.34h1.4l1.02 4.33 1.3-4.34h1.07l1.32 4.38zm7.14 2.08c-.9 0-1.63-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.13-1.2.37-1.7.25-.5.6-.88 1.04-1.16.44-.28.93-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.04.52.22.94.52 1.24.3.3.7.46 1.16.46.65 0 1.2-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.17-5.43c-.38 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.72v-.1c-.03-.48-.16-.84-.38-1.1-.23-.23-.54-.35-.93-.35zm6.34 5.3h-1.42v-9h1.42v9zm6.68 0v-8.53h2.52c.75 0 1.42.17 2 .5.6.34 1.04.82 1.36 1.43.32.62.48 1.33.48 2.12v.43c0 .8-.16 1.52-.48 2.13-.32.62-.78 1.1-1.38 1.42-.6.33-1.28.5-2.05.5h-2.45zm1.48-7.34v6.16h.97c.77 0 1.37-.25 1.8-.73.4-.5.6-1.2.62-2.1v-.48c0-.93-.2-1.64-.6-2.12-.4-.5-1-.74-1.76-.74h-1.04zm8.73 7.34h-1.42v-6.34h1.43V157zm-1.5-8c0-.2.06-.4.2-.53.14-.15.34-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.26 0-.46-.06-.6-.2-.14-.14-.2-.32-.2-.54zm7.6 6.28c0-.26-.1-.45-.3-.58-.2-.14-.56-.25-1.05-.35-.48-.1-.88-.23-1.2-.4-.72-.33-1.07-.83-1.07-1.5 0-.53.24-1 .7-1.36.46-.37 1.04-.56 1.75-.56.76 0 1.37.2 1.84.57.46.38.7.87.7 1.46h-1.43c0-.27-.1-.5-.3-.68-.2-.18-.48-.27-.82-.27-.3 0-.56.08-.76.23-.2.14-.3.33-.3.58 0 .23.1.4.27.52.18.12.55.24 1.1.36.57.13 1 .27 1.33.44.32.17.55.38.7.6.16.25.24.54.24.88 0 .57-.24 1.03-.7 1.4-.48.34-1.1.52-1.87.52-.52 0-.98-.1-1.4-.28-.4-.2-.7-.45-.94-.78-.22-.33-.34-.68-.34-1.06h1.38c.02.34.14.6.38.78.23.18.54.27.93.27.36 0 .65-.07.84-.2.2-.16.3-.34.3-.57zm6.44 1.84c-.9 0-1.63-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.13-1.2.37-1.7s.6-.88 1.03-1.16c.44-.28.93-.42 1.48-.42.87 0 1.54.28 2 .83.48.55.7 1.33.7 2.34v.58h-4.13c.04.52.22.94.52 1.24.3.3.7.46 1.15.46.65 0 1.2-.26 1.6-.8l.76.74c-.24.38-.58.67-1 .88-.43.2-.9.32-1.43.32zm-.17-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.03-.48-.15-.84-.37-1.1-.23-.23-.54-.35-.93-.35zm8.6 5.3c-.06-.12-.1-.32-.16-.6-.45.48-1 .72-1.66.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.87v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.1-.68.35-1 .23-.3.54-.53.94-.7.4-.17.83-.26 1.32-.26.75 0 1.34.2 1.78.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.56-1.03c.28 0 .55-.06.8-.2.24-.14.43-.32.55-.55v-1.2h-.77c-.53 0-.93.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.2.16.44.24.74.24zm8.82-.7c0-.25-.1-.44-.3-.57-.22-.14-.57-.25-1.05-.35-.48-.1-.88-.23-1.2-.4-.7-.33-1.07-.83-1.07-1.5 0-.53.23-1 .7-1.36.45-.37 1.04-.56 1.75-.56.76 0 1.37.2 1.84.57.46.38.7.87.7 1.46h-1.43c0-.27-.1-.5-.3-.68-.22-.18-.48-.27-.82-.27-.3 0-.57.08-.77.23-.18.14-.28.33-.28.58 0 .23.1.4.27.52.18.12.55.24 1.1.36.57.13 1 .27 1.32.44.32.17.56.38.7.6.17.25.24.54.24.88 0 .57-.23 1.03-.7 1.4-.48.34-1.1.52-1.86.52-.52 0-1-.1-1.4-.28-.4-.2-.7-.45-.94-.78-.23-.33-.34-.68-.34-1.06h1.38c.02.34.15.6.38.78.24.18.55.27.93.27.4 0 .67-.07.87-.2.2-.16.3-.34.3-.57zm6.43 1.85c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.12-1.2.37-1.7.24-.5.58-.88 1.02-1.16.45-.28.94-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.04.52.2.94.52 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.26.38-.6.67-1.02.88-.42.2-.9.32-1.43.32zm-.18-5.43c-.4 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.15-.84-.37-1.1-.22-.23-.53-.35-.93-.35zm14.76-2.04h-2.66V157h-1.47v-7.34h-2.64v-1.2h6.78v1.2zm4.92 2.3c-.2-.03-.38-.05-.58-.05-.65 0-1.1.26-1.32.76V157h-1.42v-6.34h1.36l.03.7c.35-.54.82-.82 1.43-.82.2 0 .37.03.5.1v1.32zm4.58 5.16c-.9 0-1.63-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27v-.18c0-.63.12-1.2.36-1.7.26-.5.6-.88 1.04-1.16.44-.28.93-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.04.52.22.94.53 1.24.3.3.7.46 1.16.46.65 0 1.2-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.17-5.43c-.38 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.72v-.1c-.03-.48-.16-.84-.38-1.1-.23-.23-.53-.35-.93-.35zm8.62 5.3c-.07-.12-.12-.32-.17-.6-.45.48-1 .72-1.66.72-.65 0-1.17-.18-1.57-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.88v-.42c0-.32-.1-.58-.27-.78-.18-.2-.46-.3-.84-.3-.33 0-.6.1-.8.25-.2.16-.32.37-.32.62h-1.42c0-.36.12-.68.35-1 .24-.3.55-.53.95-.7.4-.17.84-.26 1.32-.26.75 0 1.34.2 1.78.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.57-1.03c.28 0 .55-.06.8-.2.24-.14.43-.32.56-.55v-1.2h-.76c-.53 0-.93.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.18.16.43.24.73.24zm7.05-6.85v1.54h1.12v1.05h-1.12v3.55c0 .25.05.42.15.53.1.1.26.16.5.16.17 0 .34-.02.5-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.04v-1.54h1.42zm4.55 1.54l.04.66c.44-.52 1.04-.78 1.82-.78.85 0 1.43.33 1.74.98.46-.65 1.1-.98 1.94-.98.7 0 1.22.2 1.57.58.34.4.5.96.52 1.7V157h-1.43v-4.13c0-.4-.1-.7-.27-.88-.17-.2-.46-.3-.87-.3-.32 0-.6.1-.8.27-.2.17-.34.4-.43.68V157h-1.4v-4.17c-.03-.75-.4-1.12-1.16-1.12-.57 0-.97.24-1.2.7v4.6h-1.43v-6.34h1.35zm12.9 6.46c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.13-1.2.37-1.7.25-.5.6-.88 1.03-1.16.44-.28.94-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.05.52.22.94.53 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.27.38-.6.67-1.03.88-.42.2-.9.32-1.43.32zm-.18-5.43c-.4 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.15-.84-.37-1.1-.22-.23-.53-.35-.93-.35zm6.14-1.04l.05.73c.47-.57 1.1-.86 1.85-.86 1.32 0 2 .76 2 2.27v4.2h-1.4v-4.1c0-.4-.1-.7-.27-.9-.17-.2-.46-.3-.85-.3-.58 0-1 .27-1.3.8v4.5h-1.4v-6.34h1.33zm8.15-1.54v1.54h1.12v1.05h-1.12v3.55c0 .25.05.42.14.53.1.1.26.16.5.16.17 0 .34-.02.5-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.05v-1.06h1.05v-1.54h1.42zM764.78 347.83V351h-1.48v-8.53h3.26c.96 0 1.7.25 2.27.74.56.5.84 1.17.84 1.98 0 .84-.27 1.5-.82 1.95-.55.47-1.32.7-2.3.7h-1.77zm0-1.2h1.78c.53 0 .93-.1 1.2-.36.3-.25.43-.6.43-1.08 0-.47-.15-.84-.44-1.1-.28-.3-.66-.43-1.16-.44h-1.82v2.98zm10.78 4.37c-.07-.12-.12-.32-.17-.6-.46.48-1.02.72-1.67.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.87v-.42c0-.32-.1-.58-.27-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.38-.17.83-.26 1.3-.26.76 0 1.35.2 1.8.56.43.38.66.9.67 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.44zm-1.57-1.03c.27 0 .54-.06.8-.2.23-.14.42-.32.54-.55v-1.2h-.76c-.53 0-.93.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.18.16.43.24.73.24zm8.05 1.15c-.9 0-1.63-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27v-.18c0-.63.12-1.2.36-1.7.25-.5.6-.88 1.03-1.16.45-.28.94-.42 1.5-.42.85 0 1.52.28 2 .83.46.55.7 1.33.7 2.34v.58h-4.15c.05.52.22.94.53 1.24.3.3.7.46 1.15.46.66 0 1.2-.26 1.6-.8l.77.74c-.26.38-.6.67-1.02.88-.43.2-.9.32-1.43.32zm-.17-5.43c-.4 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.15-.84-.37-1.1-.22-.23-.52-.35-.92-.35zm4.55 2.08c0-.97.23-1.76.68-2.35.47-.6 1.07-.9 1.83-.9.68 0 1.22.25 1.63.72V342H792v9h-1.3l-.07-.66c-.43.52-1 .78-1.7.78-.75 0-1.35-.3-1.8-.9-.47-.6-.7-1.4-.7-2.44zm1.43.13c0 .65.12 1.15.37 1.52.25.36.6.54 1.06.54.57 0 1-.26 1.26-.78v-2.7c-.26-.52-.68-.77-1.26-.77-.46 0-.82.2-1.07.56-.25.36-.37.9-.37 1.65zM796 351h-1.44v-6.34H796V351zm-1.52-8c0-.2.06-.4.2-.53.14-.15.34-.22.6-.22.26 0 .46.07.6.22.14.14.2.32.2.54 0 .23-.06.4-.2.55-.14.14-.34.2-.6.2-.26 0-.46-.06-.6-.2-.14-.14-.2-.32-.2-.54zm7.85 8c-.07-.12-.12-.32-.17-.6-.45.48-1 .72-1.66.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.2-.54 2.14-.54h.87v-.42c0-.32-.08-.58-.26-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.1-.68.35-1 .23-.3.54-.53.94-.7.4-.17.83-.26 1.32-.26.75 0 1.34.2 1.78.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.57-1.03c.28 0 .55-.06.8-.2.24-.14.43-.32.55-.55v-1.2h-.75c-.53 0-.93.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.18.16.43.24.73.24zm7.05-6.85v1.54h1.13v1.05h-1.12v3.55c0 .25.06.42.16.53.1.1.26.16.5.16.17 0 .34-.02.5-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.05v-1.06h1.04v-1.54h1.4zm6.54 2.84c-.2-.03-.38-.05-.58-.05-.65 0-1.1.26-1.32.76V351h-1.42v-6.34h1.36l.03.7c.35-.54.83-.82 1.44-.82.2 0 .37.03.5.08v1.34zm3.4 5.04h-1.4v-6.34h1.4V351zm-1.5-8c0-.2.07-.4.2-.53.15-.15.35-.22.6-.22.26 0 .46.07.6.22.14.14.2.32.2.54 0 .23-.06.4-.2.55-.14.14-.34.2-.6.2-.25 0-.45-.06-.6-.2-.13-.14-.2-.32-.2-.54zm6.67 6.98c.36 0 .66-.1.9-.3.23-.22.35-.47.37-.78h1.34c0 .4-.13.77-.36 1.1-.23.35-.54.62-.94.82-.4.2-.82.3-1.28.3-.88 0-1.6-.3-2.1-.86-.52-.58-.78-1.37-.78-2.38v-.15c0-.96.25-1.74.77-2.32.53-.57 1.23-.86 2.12-.86.75 0 1.37.22 1.84.66.48.44.73 1.02.75 1.73h-1.33c-.02-.36-.14-.66-.38-.9-.24-.23-.53-.34-.9-.34-.45 0-.8.15-1.06.5-.25.32-.38.83-.38 1.5v.24c0 .68.12 1.2.37 1.53.25.34.6.5 1.08.5zm13.73-2.6h-3.44V351h-1.5v-8.53h5.43v1.2h-3.94v2.53h3.43v1.18zm5.2 3.74c-.9 0-1.63-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27v-.18c0-.63.12-1.2.36-1.7.25-.5.6-.88 1.03-1.16.43-.28.93-.42 1.47-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.05.52.22.94.53 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.26.38-.6.67-1.02.88-.42.2-.9.32-1.43.32zm-.17-5.43c-.4 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.15-.84-.37-1.1-.23-.23-.54-.35-.94-.35zm7.6 5.42c-.9 0-1.62-.3-2.18-.86s-.84-1.32-.84-2.27v-.18c0-.63.12-1.2.36-1.7.25-.5.6-.88 1.03-1.16.44-.28.94-.42 1.48-.42.87 0 1.54.28 2 .83.48.55.72 1.33.72 2.34v.58h-4.15c.05.52.22.94.53 1.24.3.3.7.46 1.15.46.66 0 1.2-.26 1.6-.8l.77.74c-.26.38-.6.67-1.02.88-.42.2-.9.32-1.43.32zm-.16-5.43c-.4 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.15-.84-.37-1.1-.22-.23-.53-.35-.93-.35zm4.55 2.08c0-.97.23-1.76.68-2.35.46-.6 1.06-.9 1.83-.9.67 0 1.2.25 1.62.72V342h1.43v9h-1.28l-.07-.66c-.43.52-1 .78-1.7.78-.75 0-1.35-.3-1.8-.9-.47-.6-.7-1.4-.7-2.44zm1.43.13c0 .65.12 1.15.37 1.52.25.36.6.54 1.06.54.6 0 1-.26 1.28-.78v-2.7c-.26-.52-.68-.77-1.26-.77-.46 0-.82.2-1.07.56-.25.36-.37.9-.37 1.65zm8.13 3.1h-1.42v-6.34h1.43V351zm-1.5-8c0-.2.07-.4.2-.53.14-.15.34-.22.6-.22.26 0 .46.07.6.22.14.14.2.32.2.54 0 .23-.06.4-.2.55-.14.14-.34.2-.6.2-.26 0-.46-.06-.6-.2-.13-.14-.2-.32-.2-.54zm5.38 1.66l.04.73c.47-.57 1.08-.86 1.85-.86 1.32 0 2 .76 2 2.27v4.2h-1.4v-4.1c0-.4-.1-.7-.27-.9-.18-.2-.46-.3-.86-.3-.57 0-1 .27-1.28.8v4.5h-1.42v-6.34h1.34zm6.1 3.12c0-.98.23-1.77.7-2.36.46-.58 1.07-.88 1.84-.88.72 0 1.3.25 1.7.76l.07-.64h1.27v6.15c0 .84-.26 1.5-.77 1.98-.52.48-1.22.72-2.1.72-.46 0-.92-.1-1.36-.3-.44-.2-.78-.44-1-.75l.66-.86c.44.5.98.77 1.62.77.47 0 .85-.13 1.12-.38.27-.27.4-.64.4-1.14v-.43c-.4.46-.95.7-1.63.7-.73 0-1.34-.3-1.8-.9-.48-.6-.72-1.4-.72-2.45zm1.42.13c0 .64.13 1.14.4 1.5.25.37.6.56 1.07.56.58 0 1-.25 1.28-.74v-2.8c-.27-.47-.7-.7-1.27-.7-.47 0-.83.17-1.1.55-.25.37-.38.9-.38 1.64zm12.32 3.1h-1.47v-8.53h1.47V351zm6.24-1.72c0-.26-.1-.45-.3-.58-.22-.14-.57-.25-1.05-.35-.47-.1-.88-.23-1.2-.4-.7-.33-1.07-.83-1.07-1.5 0-.53.23-1 .7-1.36.45-.37 1.04-.56 1.75-.56.76 0 1.37.2 1.84.57.46.38.7.87.7 1.46h-1.43c0-.27-.1-.5-.3-.68-.22-.18-.48-.27-.82-.27-.3 0-.57.08-.77.23-.18.14-.28.33-.28.58 0 .23.1.4.27.52.18.12.55.24 1.1.36.57.13 1 .27 1.32.44.32.17.56.38.7.6.17.25.24.54.24.88 0 .57-.23 1.03-.7 1.4-.48.34-1.1.52-1.86.52-.52 0-1-.1-1.4-.28-.4-.2-.7-.45-.94-.78-.23-.33-.34-.68-.34-1.06h1.38c.02.34.15.6.38.78.24.18.55.27.93.27.4 0 .67-.07.87-.2.2-.16.3-.34.3-.57zm7.2 0c0-.26-.1-.45-.32-.58-.2-.14-.55-.25-1.04-.35-.48-.1-.9-.23-1.2-.4-.72-.33-1.08-.83-1.08-1.5 0-.53.23-1 .7-1.36.46-.37 1.04-.56 1.75-.56.76 0 1.37.2 1.84.57.48.38.7.87.7 1.46h-1.4c0-.27-.12-.5-.32-.68-.2-.18-.47-.27-.8-.27-.32 0-.57.08-.77.23-.2.14-.3.33-.3.58 0 .23.1.4.3.52.17.12.54.24 1.1.36.56.13 1 .27 1.32.44.3.17.55.38.7.6.16.25.24.54.24.88 0 .57-.24 1.03-.7 1.4-.48.34-1.1.52-1.87.52-.53 0-1-.1-1.4-.28-.4-.2-.72-.45-.95-.78-.22-.33-.34-.68-.34-1.06h1.4c.02.34.14.6.38.78.23.18.54.27.93.27.38 0 .67-.07.86-.2.2-.16.3-.34.3-.57zm7.48 1.1c-.42.5-1 .74-1.78.74-.7 0-1.2-.2-1.57-.6-.36-.4-.54-1-.54-1.75v-4.1h1.43v4.08c0 .8.32 1.2 1 1.2.68 0 1.15-.24 1.4-.74v-4.54h1.4V351h-1.33l-.03-.62zm6.62.74c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.12-1.2.37-1.7.23-.5.57-.88 1.02-1.16.44-.28.93-.42 1.47-.42.86 0 1.52.28 2 .83.46.55.7 1.33.7 2.34v.58h-4.14c.04.52.2.94.52 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.25.38-.6.67-1.02.88-.42.2-.9.32-1.42.32zm-.17-5.43c-.4 0-.72.12-.96.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.15-.84-.37-1.1-.2-.23-.52-.35-.9-.35zm8.36 3.58c0-.26-.1-.45-.32-.58-.2-.14-.55-.25-1.04-.35-.48-.1-.88-.23-1.2-.4-.72-.33-1.08-.83-1.08-1.5 0-.53.23-1 .7-1.36.46-.37 1.04-.56 1.75-.56.76 0 1.37.2 1.84.57.48.38.7.87.7 1.46h-1.4c0-.27-.1-.5-.32-.68-.2-.18-.47-.27-.8-.27-.32 0-.57.08-.77.23-.2.14-.3.33-.3.58 0 .23.1.4.3.52.17.12.54.24 1.1.36.56.13 1 .27 1.32.44.32.17.55.38.7.6.16.25.24.54.24.88 0 .57-.24 1.03-.7 1.4-.48.34-1.1.52-1.87.52-.53 0-1-.1-1.4-.28-.4-.2-.72-.45-.95-.78-.22-.33-.34-.68-.34-1.06h1.4c.02.34.14.6.38.78.23.18.54.27.93.27.38 0 .67-.07.86-.2.2-.16.3-.34.3-.57zM996.5 488.66h-2.66V496h-1.47v-7.34h-2.64v-1.2h6.77v1.2zm4.92 2.3c-.2-.03-.38-.05-.58-.05-.65 0-1.1.26-1.32.76V496h-1.42v-6.34h1.36l.03.7c.34-.54.8-.82 1.42-.82.2 0 .37.03.5.08v1.34zm4.58 5.16c-.9 0-1.63-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27v-.18c0-.63.12-1.2.36-1.7.25-.5.6-.88 1.03-1.16.44-.28.93-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.04.52.22.94.53 1.24.3.3.7.46 1.15.46.66 0 1.2-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.17-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.72v-.1c-.03-.48-.16-.84-.38-1.1-.23-.23-.53-.35-.93-.35zm8.6 5.3c-.06-.12-.1-.32-.16-.6-.45.48-1 .72-1.66.72-.63 0-1.15-.18-1.55-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.88v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.84-.3-.3 0-.58.1-.78.25-.2.16-.32.37-.32.62h-1.42c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.32-.26.74 0 1.33.2 1.77.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.46zm-1.56-1.03c.28 0 .55-.06.8-.2.24-.14.43-.32.56-.55v-1.2h-.77c-.53 0-.93.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.18.16.43.24.73.24zm7.05-6.85v1.54h1.12v1.05h-1.12v3.55c0 .25.05.42.15.53.1.1.26.16.5.16.18 0 .34-.02.5-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.04v-1.54h1.42zm4.55 1.54l.04.66c.46-.52 1.07-.78 1.84-.78.85 0 1.43.33 1.74.98.46-.65 1.1-.98 1.94-.98.7 0 1.22.2 1.57.58.33.4.5.96.5 1.7V496h-1.4v-4.13c0-.4-.1-.7-.28-.88-.17-.2-.46-.3-.87-.3-.32 0-.6.1-.8.27-.2.17-.34.4-.42.68V496h-1.42v-4.17c0-.75-.4-1.12-1.14-1.12-.57 0-.97.24-1.2.7v4.6h-1.43v-6.34h1.34zm12.9 6.46c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.12-1.2.37-1.7.24-.5.58-.88 1.02-1.16.45-.28.94-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.05.52.22.94.53 1.24.3.3.68.46 1.15.46.65 0 1.18-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.43.2-.9.32-1.44.32zm-.18-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.03-.48-.16-.84-.38-1.1-.22-.23-.53-.35-.93-.35zm6.13-1.04l.04.73c.47-.57 1.1-.86 1.85-.86 1.32 0 2 .76 2.02 2.27v4.2h-1.43v-4.1c0-.4-.08-.7-.25-.9-.17-.2-.46-.3-.85-.3-.58 0-1 .27-1.28.8v4.5H1042v-6.34h1.33zm8.14-1.54v1.54h1.12v1.05h-1.13v3.55c0 .25.05.42.14.53.1.1.28.16.53.16.16 0 .33-.02.5-.06v1.1c-.33.1-.64.14-.94.14-1.1 0-1.65-.6-1.65-1.8v-3.6H1049v-1.06h1.05v-1.54h1.42zm6.93 4.65c0-.62.12-1.18.37-1.68.24-.5.6-.9 1.03-1.16.45-.26.96-.4 1.54-.4.85 0 1.55.28 2.08.83.54.55.82 1.28.87 2.2v.32c0 .62-.13 1.18-.37 1.67-.24.5-.58.87-1.03 1.14-.45.28-.96.42-1.55.42-.9 0-1.6-.3-2.15-.9-.53-.6-.8-1.4-.8-2.38v-.07zm1.42.12c0 .65.14 1.16.4 1.53.28.37.65.55 1.13.55.48 0 .86-.2 1.12-.56.27-.38.4-.93.4-1.65 0-.64-.13-1.15-.4-1.52-.28-.38-.66-.56-1.13-.56-.47 0-.84.17-1.1.54-.28.37-.42.92-.42 1.65zm7.18 3.1v-5.3h-.97v-1.04h.97v-.58c0-.7.2-1.25.58-1.63.4-.38.94-.57 1.64-.57.25 0 .52.03.8.1l-.03 1.12c-.17-.04-.35-.05-.56-.05-.68 0-1.02.35-1.02 1.05v.56h1.3v1.05h-1.3v5.3H1067zm10.8-8.53l2.46 6.54 2.45-6.53h1.93V496h-1.48v-2.8l.15-3.77-2.52 6.57h-1.06l-2.5-6.57.13 3.76v2.8h-1.47v-8.53h1.92zm12.24 8.65c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.12-1.2.37-1.7.24-.5.58-.88 1.03-1.16.44-.28.93-.42 1.47-.42.87 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.13c.04.52.2.94.52 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.25.38-.6.67-1.02.88-.42.2-.9.32-1.42.32zm-.17-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.15-.84-.37-1.1-.23-.23-.54-.35-.93-.35zm6.13-1.04l.05.73c.46-.57 1.08-.86 1.84-.86 1.3 0 1.98.76 2 2.27v4.2h-1.42v-4.1c0-.4-.08-.7-.26-.9-.17-.2-.46-.3-.85-.3-.57 0-1 .27-1.28.8v4.5h-1.44v-6.34h1.34zm6.1 3.1c0-.6.1-1.17.36-1.67.25-.5.6-.9 1.04-1.16.44-.26.95-.4 1.53-.4.86 0 1.55.28 2.1.83.52.55.8 1.28.85 2.2v.32c0 .62-.1 1.18-.35 1.67-.25.5-.6.87-1.04 1.14-.45.28-.97.42-1.56.42-.9 0-1.6-.3-2.14-.9-.54-.6-.8-1.4-.8-2.38v-.07zm1.4.13c0 .65.15 1.16.42 1.53.27.37.64.55 1.12.55.48 0 .86-.2 1.13-.56.26-.38.4-.93.4-1.65 0-.64-.14-1.15-.42-1.52-.27-.38-.65-.56-1.12-.56-.46 0-.83.17-1.1.54-.28.37-.42.92-.42 1.65zm12.24 0c0 .98-.22 1.76-.67 2.34-.44.6-1.04.88-1.8.88-.7 0-1.24-.23-1.66-.7v3.02h-1.4v-8.78h1.3l.06.64c.42-.5.98-.76 1.7-.76.78 0 1.38.3 1.82.87.44.58.66 1.38.66 2.4v.1zm-1.42-.13c0-.63-.12-1.13-.37-1.5-.26-.38-.62-.56-1.1-.56-.57 0-1 .25-1.24.73v2.8c.27.5.7.75 1.28.75.45 0 .8-.18 1.06-.55.26-.36.38-.92.38-1.66zm7.4 3.23c-.05-.12-.1-.32-.15-.6-.45.48-1 .72-1.66.72-.63 0-1.15-.18-1.55-.55-.4-.36-.6-.8-.6-1.35 0-.67.24-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.87v-.42c0-.32-.1-.58-.27-.78-.2-.2-.47-.3-.84-.3-.32 0-.58.1-.8.25-.2.16-.3.37-.3.62h-1.42c0-.36.1-.68.34-1 .23-.3.55-.53.94-.7.4-.17.84-.26 1.33-.26.73 0 1.33.2 1.77.56.44.38.66.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.47zm-1.55-1.03c.28 0 .54-.06.8-.2.24-.14.43-.32.55-.55v-1.2h-.77c-.52 0-.92.1-1.18.28-.27.18-.4.44-.4.78 0 .27.1.5.27.65.18.16.42.24.73.24zm9.1.4c-.4.5-1 .75-1.77.75-.7 0-1.2-.2-1.56-.6-.36-.4-.53-1-.53-1.75v-4.1h1.43v4.08c0 .8.33 1.2 1 1.2.7 0 1.16-.24 1.4-.74v-4.54h1.43V496h-1.35l-.02-.62zm7.4-1.1c0-.25-.12-.44-.32-.57-.2-.14-.56-.25-1.04-.35-.48-.1-.88-.23-1.2-.4-.72-.33-1.07-.83-1.07-1.5 0-.53.23-1 .7-1.36.45-.37 1.03-.56 1.75-.56.75 0 1.37.2 1.83.57.48.38.7.87.7 1.46h-1.4c0-.27-.1-.5-.32-.68-.2-.18-.47-.27-.8-.27-.32 0-.57.08-.77.23-.2.14-.28.33-.28.58 0 .23.1.4.27.52s.55.24 1.1.36c.56.13 1 .27 1.32.44.32.17.55.38.7.6.16.25.24.54.24.88 0 .57-.24 1.03-.7 1.4-.48.34-1.1.52-1.87.52-.53 0-1-.1-1.4-.28-.4-.2-.72-.45-.94-.78-.23-.33-.34-.68-.34-1.06h1.38c.02.34.14.6.38.78.23.18.54.27.93.27.4 0 .67-.07.87-.2.2-.16.3-.34.3-.57zm6.42 1.85c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.12-1.2.36-1.7.25-.5.6-.88 1.03-1.16.44-.28.93-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.03.52.2.94.52 1.24.3.3.7.46 1.15.46.66 0 1.2-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.18-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.73v-.1c-.03-.48-.16-.84-.38-1.1-.23-.23-.53-.35-.93-.35zM174.08 582v-8.53H177c.97 0 1.7.2 2.2.58.5.4.77.96.77 1.73 0 .4-.1.74-.32 1.05-.2.3-.52.56-.93.73.47.12.82.36 1.07.7.25.35.37.77.37 1.25 0 .8-.25 1.43-.77 1.86-.5.43-1.25.64-2.2.64h-3.12zm1.5-3.85v2.67h1.63c.48 0 .84-.12 1.1-.35.26-.23.4-.55.4-.96 0-.88-.46-1.33-1.36-1.35h-1.77zm0-1.1H177c.46 0 .82-.1 1.08-.3.26-.2.4-.5.4-.9s-.13-.72-.37-.9c-.24-.2-.6-.3-1.12-.3h-1.43v2.4zm9.73 5.07c-.9 0-1.63-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27v-.18c0-.63.13-1.2.37-1.7s.6-.88 1.03-1.16c.44-.28.93-.42 1.47-.42.87 0 1.53.28 2 .83.48.55.7 1.33.7 2.34v.58h-4.13c.05.52.23.94.53 1.24.3.3.7.46 1.16.46.64 0 1.17-.26 1.58-.8l.77.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.16-5.43c-.4 0-.7.12-.95.4-.25.27-.4.65-.47 1.14h2.72v-.1c-.04-.48-.16-.84-.4-1.1-.2-.23-.52-.35-.9-.35zm6.14-1.04l.04.73c.47-.57 1.08-.86 1.84-.86 1.32 0 2 .76 2.02 2.27v4.2h-1.42v-4.1c0-.4-.1-.7-.26-.9-.18-.2-.46-.3-.86-.3-.57 0-1 .27-1.28.8v4.5h-1.42v-6.34h1.34zm7.86 6.34h-1.42v-6.34h1.42V582zm-1.5-8c0-.2.06-.4.2-.53.14-.15.34-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.26 0-.46-.06-.6-.2-.14-.14-.2-.32-.2-.54zm3.8 4.78c0-.98.24-1.77.7-2.36.46-.58 1.08-.88 1.84-.88.73 0 1.3.25 1.7.76l.07-.64h1.3v6.15c0 .84-.27 1.5-.8 1.98-.5.48-1.2.72-2.1.72-.45 0-.9-.1-1.35-.3-.44-.2-.78-.44-1-.75l.66-.86c.44.5.98.77 1.62.77.47 0 .85-.13 1.12-.38.27-.27.4-.64.4-1.14v-.43c-.4.46-.95.7-1.63.7-.74 0-1.35-.3-1.82-.9-.47-.6-.7-1.4-.7-2.45zm1.42.13c0 .64.13 1.14.4 1.5.25.37.6.56 1.07.56.58 0 1-.25 1.28-.74v-2.8c-.26-.47-.68-.7-1.25-.7-.47 0-.84.17-1.1.55-.26.37-.4.9-.4 1.64zm7.96-3.24l.04.73c.47-.57 1.08-.86 1.85-.86 1.33 0 2 .76 2.02 2.27v4.2h-1.42v-4.1c0-.4-.1-.7-.26-.9-.18-.2-.46-.3-.86-.3-.57 0-1 .27-1.28.8v4.5h-1.42v-6.34h1.34zm11.96 3.17V582h-1.48v-8.53h3.26c.95 0 1.7.25 2.27.74.56.5.84 1.17.84 1.98 0 .84-.27 1.5-.82 1.95-.55.47-1.32.7-2.3.7h-1.77zm0-1.2h1.78c.53 0 .93-.1 1.2-.36.28-.25.42-.6.42-1.08 0-.47-.14-.84-.42-1.1-.28-.3-.67-.43-1.16-.44h-1.82v2.98zm10.37-.67c-.2-.03-.38-.05-.58-.05-.65 0-1.1.26-1.32.76V582h-1.42v-6.34h1.36l.02.7c.34-.54.82-.82 1.43-.82.2 0 .37.03.5.1v1.32zm1.42 1.8c0-.6.12-1.17.37-1.67s.6-.9 1.04-1.16c.44-.26.95-.4 1.53-.4.87 0 1.56.28 2.1.83.53.55.82 1.28.86 2.2v.32c0 .62-.12 1.18-.36 1.67-.24.5-.58.87-1.03 1.14-.44.28-.96.42-1.55.42-.9 0-1.6-.3-2.14-.9-.54-.6-.8-1.4-.8-2.38v-.07zm1.42.13c0 .65.13 1.16.4 1.53.27.37.64.55 1.12.55.48 0 .86-.2 1.13-.56.26-.38.4-.93.4-1.65 0-.64-.14-1.15-.42-1.52-.27-.38-.65-.56-1.12-.56-.45 0-.82.17-1.1.54-.27.37-.4.92-.4 1.65zm10.22 1.38c0-.26-.1-.45-.3-.58-.22-.14-.57-.25-1.05-.35-.5-.1-.9-.23-1.2-.4-.72-.33-1.08-.83-1.08-1.5 0-.53.22-1 .68-1.36.46-.37 1.05-.56 1.76-.56.76 0 1.37.2 1.84.57.46.38.7.87.7 1.46h-1.43c0-.27-.1-.5-.3-.68-.2-.18-.47-.27-.8-.27-.32 0-.58.08-.78.23-.2.14-.3.33-.3.58 0 .23.1.4.28.52.2.12.56.24 1.12.36.56.13 1 .27 1.3.44.33.17.57.38.72.6.15.25.22.54.22.88 0 .57-.23 1.03-.7 1.4-.48.34-1.1.52-1.86.52-.52 0-1-.1-1.4-.28-.4-.2-.7-.45-.94-.78-.23-.33-.34-.68-.34-1.06h1.38c.02.34.15.6.38.78.24.18.55.27.93.27s.66-.07.86-.2c.2-.16.3-.34.3-.57zm5.43-6.16v1.54h1.12v1.05h-1.12v3.55c0 .25.04.42.14.53.1.1.26.16.5.16.17 0 .33-.02.5-.06v1.1c-.32.1-.64.14-.94.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.04v-1.54h1.43zm7 7.88c-.07-.12-.13-.32-.17-.6-.46.48-1 .72-1.67.72-.62 0-1.14-.18-1.55-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.16-.54h.87v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.83-.3-.33 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.1-.68.33-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.33-.26.74 0 1.33.2 1.77.56.45.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.46zm-1.57-1.03c.28 0 .54-.06.8-.2.24-.14.42-.32.55-.55v-1.2h-.77c-.53 0-.92.1-1.2.28-.25.18-.4.44-.4.78 0 .27.1.5.3.65.17.16.4.24.72.24zm7.05-6.85v1.54h1.12v1.05h-1.12v3.55c0 .25.05.42.14.53.1.1.27.16.52.16.15 0 .32-.02.48-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.05v-1.54h1.43zm4.72 7.88h-1.42v-6.34h1.42V582zm-1.5-8c0-.2.06-.4.2-.53.13-.15.33-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.27 0-.47-.06-.6-.2-.14-.14-.2-.32-.2-.54zM274 581c.36 0 .65-.1.9-.3.22-.22.35-.47.36-.78h1.35c0 .4-.13.77-.36 1.1-.23.35-.55.62-.94.82-.4.2-.82.3-1.28.3-.9 0-1.6-.3-2.1-.86-.53-.58-.8-1.37-.8-2.38v-.15c0-.96.27-1.74.8-2.32.5-.57 1.2-.86 2.1-.86.75 0 1.36.22 1.84.66.47.44.72 1.02.75 1.73h-1.34c0-.36-.14-.66-.37-.9-.24-.23-.54-.34-.9-.34-.46 0-.8.15-1.06.5-.25.32-.38.83-.38 1.5v.24c0 .68.12 1.2.37 1.53.25.34.6.5 1.07.5zm15.58 1.02h-1.48v-3.8h-3.8v3.8h-1.5v-8.53h1.5v3.55h3.8v-3.55h1.48V582zm4.83-2.04l1.3-4.3h1.52l-2.52 7.3c-.4 1.07-1.04 1.6-1.97 1.6-.2 0-.44-.03-.7-.1v-1.1h.28c.37 0 .64-.05.83-.2.18-.12.32-.34.43-.64l.2-.55-2.22-6.3h1.53l1.34 4.3zm10.2-1.07c0 .98-.23 1.76-.68 2.34-.45.6-1.04.88-1.8.88-.7 0-1.24-.23-1.66-.7v3.02h-1.43v-8.78h1.32l.05.64c.42-.5 1-.76 1.7-.76.78 0 1.4.3 1.83.87.44.58.66 1.38.66 2.4v.1zm-1.43-.13c0-.63-.13-1.13-.38-1.5-.26-.38-.62-.56-1.1-.56-.57 0-1 .25-1.24.73v2.8c.25.5.68.75 1.26.75.46 0 .8-.18 1.07-.55.24-.36.37-.92.37-1.66zm6.4 3.35c-.9 0-1.62-.3-2.18-.86-.57-.56-.85-1.32-.85-2.27v-.18c0-.63.12-1.2.37-1.7.24-.5.58-.88 1.02-1.16.44-.28.94-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58H308c.05.52.22.94.53 1.24.32.3.7.46 1.17.46.65 0 1.18-.26 1.6-.8l.76.74c-.26.38-.6.67-1.02.88-.4.2-.9.32-1.42.32zm-.16-5.43c-.38 0-.7.12-.93.4-.24.27-.4.65-.46 1.14h2.72v-.1c-.03-.48-.16-.84-.38-1.1-.22-.23-.53-.35-.93-.35zm8.15.26c-.2-.03-.38-.05-.58-.05-.65 0-1.1.26-1.32.76V582h-1.42v-6.34h1.36l.02.7c.35-.54.82-.82 1.43-.82.2 0 .37.03.5.08v1.34zm7.45 1.93c0 .98-.22 1.76-.67 2.34-.44.6-1.04.88-1.8.88-.68 0-1.24-.23-1.66-.7v3.02h-1.42v-8.78h1.3l.07.64c.42-.5.98-.76 1.7-.76.78 0 1.38.3 1.82.87.44.58.66 1.38.66 2.4v.1zm-1.42-.13c0-.63-.12-1.13-.37-1.5-.25-.38-.6-.56-1.07-.56-.6 0-1 .25-1.26.73v2.8c.26.5.68.75 1.27.75.45 0 .8-.18 1.06-.55.26-.36.38-.92.38-1.66zm5.14 3.23h-1.42v-9h1.42v9zm6.34 0c-.06-.12-.12-.32-.17-.6-.46.48-1 .72-1.67.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.88v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.4-.17.83-.26 1.32-.26.74 0 1.33.2 1.77.56.43.38.66.9.67 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.44zm-1.57-1.03c.28 0 .54-.06.8-.2.24-.14.42-.32.55-.55v-1.2h-.77c-.53 0-.92.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.2.16.43.24.73.24zm8.82-.7c0-.25-.1-.44-.32-.57-.2-.14-.55-.25-1.04-.35-.48-.1-.9-.23-1.2-.4-.72-.33-1.08-.83-1.08-1.5 0-.53.23-1 .7-1.36.46-.37 1.04-.56 1.75-.56.76 0 1.37.2 1.84.57.47.38.7.87.7 1.46h-1.42c0-.27-.1-.5-.3-.68-.2-.18-.48-.27-.82-.27-.3 0-.56.08-.76.23-.2.14-.3.33-.3.58 0 .23.1.4.28.52.18.12.55.24 1.1.36.57.13 1 .27 1.33.44.3.17.55.38.7.6.16.25.24.54.24.88 0 .57-.24 1.03-.7 1.4-.48.34-1.1.52-1.87.52-.52 0-.98-.1-1.4-.28-.4-.2-.7-.45-.94-.78-.2-.33-.33-.68-.33-1.06h1.4c0 .34.13.6.37.78.23.18.54.27.93.27.37 0 .66-.07.85-.2.2-.16.3-.34.3-.57zm5.15 1.73h-1.42v-6.34h1.42V582zm-1.5-8c0-.2.06-.4.2-.53.14-.15.33-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.27 0-.46-.06-.6-.2-.14-.14-.2-.32-.2-.54zm7.84 8c-.05-.12-.1-.32-.16-.6-.45.48-1 .72-1.66.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.88v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.33-.26.74 0 1.33.2 1.77.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.56-1.03c.3 0 .55-.06.8-.2s.43-.32.56-.55v-1.2h-.77c-.53 0-.92.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.2.16.44.24.74.24zM239.74 162.22c-.08.9-.42 1.62-1 2.13-.6.5-1.37.77-2.34.77-.68 0-1.28-.16-1.8-.5-.52-.3-.92-.77-1.2-1.36-.28-.6-.43-1.28-.44-2.07v-.8c0-.8.14-1.52.43-2.13.27-.62.68-1.1 1.22-1.42.53-.33 1.15-.5 1.85-.5.94 0 1.7.26 2.27.77.57.5.9 1.23 1 2.17h-1.48c-.07-.63-.24-1.07-.53-1.34-.3-.27-.7-.4-1.26-.4-.65 0-1.14.23-1.5.7-.34.47-.5 1.16-.52 2.07v.76c0 .9.17 1.6.5 2.1.33.48.8.72 1.45.72.58 0 1.02-.13 1.3-.4.3-.25.5-.7.56-1.3h1.48zm1.92-.45c0-.62.12-1.18.37-1.68s.6-.9 1.04-1.16c.44-.26.95-.4 1.53-.4.86 0 1.55.28 2.1.83.52.55.8 1.28.85 2.2v.32c0 .62-.1 1.18-.35 1.67-.24.5-.6.87-1.04 1.14-.44.28-.96.42-1.55.42-.88 0-1.6-.3-2.13-.9-.54-.6-.8-1.4-.8-2.38v-.07zm1.42.12c0 .65.14 1.16.4 1.53.28.37.65.55 1.13.55.5 0 .87-.2 1.14-.56.26-.38.4-.93.4-1.65 0-.64-.14-1.15-.42-1.52-.27-.38-.64-.56-1.12-.56-.46 0-.83.17-1.1.54-.28.37-.42.92-.42 1.65zm8-3.24l.04.73c.47-.57 1.1-.86 1.85-.86 1.32 0 2 .76 2 2.27v4.2h-1.4v-4.1c0-.4-.1-.7-.27-.9-.18-.2-.46-.3-.85-.3-.58 0-1 .27-1.3.8v4.5h-1.4v-6.34h1.33zm7.84 0v6.9c0 .65-.16 1.15-.48 1.5-.33.33-.8.5-1.42.5-.26 0-.5-.03-.76-.1v-1.12c.15.03.32.05.5.05.48 0 .72-.27.74-.78v-6.96h1.42zm-1.55-1.65c0-.2.07-.4.2-.53.15-.15.35-.22.6-.22.26 0 .46.07.6.22.14.14.2.32.2.54 0 .23-.06.4-.2.55-.14.14-.34.2-.6.2-.25 0-.45-.06-.6-.2-.13-.14-.2-.32-.2-.54zm7.9 7.38c-.4.5-1 .74-1.77.74-.7 0-1.2-.2-1.56-.6-.36-.4-.53-1-.53-1.75v-4.1h1.43v4.08c0 .8.34 1.2 1 1.2.7 0 1.16-.24 1.4-.74v-4.54h1.43V165h-1.34l-.04-.62zm5.16-5.72l.04.73c.47-.57 1.08-.86 1.85-.86 1.32 0 2 .76 2 2.27v4.2h-1.4v-4.1c0-.4-.1-.7-.27-.9-.18-.2-.46-.3-.86-.3-.58 0-1 .27-1.3.8v4.5h-1.4v-6.34h1.33zm8.96 5.32c.34 0 .64-.1.87-.3.23-.22.36-.47.38-.78H282c-.03.4-.15.77-.38 1.1-.23.35-.54.62-.94.82-.4.2-.82.3-1.28.3-.88 0-1.6-.3-2.1-.86-.53-.58-.8-1.37-.8-2.38v-.15c0-.96.27-1.74.8-2.32.5-.57 1.2-.86 2.1-.86.75 0 1.37.22 1.84.66.47.44.72 1.02.75 1.73h-1.35c-.02-.36-.14-.66-.38-.9-.23-.23-.52-.34-.88-.34-.48 0-.83.15-1.08.5-.25.32-.38.83-.38 1.5v.24c0 .68.12 1.2.37 1.53.26.34.62.5 1.1.5zm6.45-6.86v1.54h1.12v1.05h-1.12v3.55c0 .25.04.42.14.53.1.1.26.16.5.16.17 0 .33-.02.5-.06v1.1c-.32.1-.64.14-.94.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.04v-1.54h1.43zm4.72 7.88h-1.43v-6.34h1.43V165zm-1.5-8c0-.2.05-.4.2-.53.13-.15.33-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.27 0-.47-.06-.6-.2-.15-.14-.2-.32-.2-.54zm6.28 6.2l1.34-4.54h1.47l-2.2 6.34h-1.24l-2.2-6.34h1.46l1.35 4.54zm6.22 1.8h-1.43v-6.34h1.43V165zm-1.5-8c0-.2.05-.4.2-.53.13-.15.33-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.27 0-.47-.06-.6-.2-.15-.14-.2-.32-.2-.54zm5.83.12v1.54h1.12v1.05h-1.12v3.55c0 .25.05.42.14.53.1.1.27.16.52.16.16 0 .33-.02.5-.06v1.1c-.33.1-.64.14-.94.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.05v-1.06h1.05v-1.54h1.42zm4.72 7.88h-1.42v-6.34h1.42V165zm-1.5-8c0-.2.06-.4.2-.53.14-.15.34-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.26 0-.46-.06-.6-.2-.14-.14-.2-.32-.2-.54zm7.6 6.28c0-.26-.1-.45-.3-.58-.22-.14-.56-.25-1.05-.35-.48-.1-.9-.23-1.2-.4-.72-.33-1.08-.83-1.08-1.5 0-.53.22-1 .68-1.36.47-.37 1.05-.56 1.76-.56.76 0 1.37.2 1.84.57.47.38.7.87.7 1.46h-1.42c0-.27-.1-.5-.3-.68-.2-.18-.48-.27-.82-.27-.3 0-.57.08-.76.23-.2.14-.3.33-.3.58 0 .23.1.4.28.52.18.12.55.24 1.1.36.57.13 1 .27 1.33.44.3.17.54.38.7.6.15.25.23.54.23.88 0 .57-.24 1.03-.7 1.4-.5.34-1.1.52-1.87.52-.52 0-.98-.1-1.4-.28-.4-.2-.7-.45-.94-.78-.22-.33-.34-.68-.34-1.06h1.38c.02.34.15.6.4.78.22.18.53.27.92.27.37 0 .66-.07.85-.2.2-.16.3-.34.3-.57zM831.83 29h-1.47v-8.53h1.47V29zm2.82 0v-8.53h2.93c.96 0 1.7.2 2.2.58.5.4.76.96.76 1.73 0 .4-.1.74-.32 1.05-.2.3-.52.56-.93.73.46.12.8.36 1.06.7.26.35.38.77.38 1.25 0 .8-.25 1.43-.77 1.86-.5.43-1.25.64-2.2.64h-3.12zm1.5-3.85v2.67h1.63c.47 0 .83-.12 1.1-.35.25-.23.4-.55.4-.96 0-.88-.47-1.33-1.37-1.35h-1.76zm0-1.1h1.44c.45 0 .8-.1 1.07-.3.26-.2.4-.5.4-.9s-.13-.72-.37-.9c-.24-.2-.6-.3-1.12-.3h-1.44v2.4zm11.53 2.75c0-.37-.13-.66-.4-.86-.26-.2-.73-.4-1.42-.62-.7-.2-1.23-.44-1.64-.7-.78-.48-1.17-1.12-1.17-1.9 0-.7.28-1.26.85-1.7.56-.45 1.28-.67 2.18-.67.6 0 1.12.1 1.6.33.45.22.82.53 1.08.93.27.42.4.87.4 1.36h-1.48c0-.45-.14-.8-.42-1.05-.27-.24-.67-.36-1.2-.36-.48 0-.85.1-1.12.3-.27.2-.4.5-.4.87 0 .33.14.6.43.8.3.2.77.4 1.43.6.66.2 1.2.43 1.6.68.4.25.7.54.88.87.2.32.3.7.3 1.14 0 .7-.3 1.27-.83 1.7-.55.4-1.3.62-2.22.62-.62 0-1.18-.12-1.7-.35-.52-.22-.92-.54-1.2-.94-.3-.4-.44-.87-.44-1.4h1.47c0 .48.16.85.48 1.12.32.26.78.4 1.38.4.52 0 .9-.1 1.16-.32.25-.2.38-.48.38-.83z"/>
            <text transform="translate(0 52)" letterSpacing="1" fontSize="12" fontFamily="Roboto-Medium, Roboto" fontWeight="400">
              <tspan x=".3" y="11">Menorrhagi</tspan> <tspan x="72.21" y="11">a</tspan>
            </text>
            <path d="M87.02 371.96c0 .83-.15 1.57-.44 2.2-.28.63-.7 1.1-1.23 1.45-.54.35-1.16.52-1.86.52-.7 0-1.32-.17-1.86-.5-.54-.35-.96-.83-1.25-1.45-.3-.63-.46-1.35-.46-2.17v-.48c0-.83.15-1.56.44-2.2.3-.64.7-1.12 1.25-1.46.54-.34 1.15-.5 1.85-.5.7 0 1.3.16 1.85.5.54.33.95.8 1.24 1.43.3.62.44 1.35.45 2.18v.48zm-1.48-.45c0-.93-.18-1.66-.54-2.16-.36-.5-.86-.76-1.52-.76-.64 0-1.14.25-1.5.75-.36.5-.55 1.22-.56 2.13v.5c0 .93.2 1.66.55 2.17.37.5.87.77 1.52.77s1.15-.25 1.5-.75c.36-.5.54-1.23.54-2.2v-.44zm6.05 2.7l1.33-4.54h1.48L92.2 376h-1.23l-2.2-6.34h1.46l1.36 4.54zm7.4 1.92c-.9 0-1.62-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27v-.18c0-.63.13-1.2.37-1.7s.6-.88 1.03-1.16c.44-.28.93-.42 1.47-.42.87 0 1.53.28 2 .83.48.55.7 1.33.7 2.34v.58h-4.13c.05.52.23.94.53 1.24.3.3.7.46 1.16.46.64 0 1.17-.26 1.58-.8l.77.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.16-5.43c-.4 0-.7.12-.95.4-.25.27-.4.65-.47 1.14h2.72v-.1c-.04-.48-.16-.84-.4-1.1-.2-.23-.52-.35-.9-.35zm8.14.26c-.2-.03-.4-.05-.58-.05-.66 0-1.1.26-1.32.76V376h-1.43v-6.34H105l.05.7c.34-.54.82-.82 1.43-.82.2 0 .37.03.5.08v1.34zm5.5 5.04c-.06-.12-.1-.32-.16-.6-.45.48-1 .72-1.66.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.88v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.33-.26.74 0 1.33.2 1.77.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.56-1.03c.28 0 .55-.06.8-.2.24-.14.43-.32.56-.55v-1.2h-.77c-.52 0-.92.1-1.18.28-.27.18-.4.44-.4.78 0 .27.1.5.27.65.18.16.42.24.72.24zm7.88 0c.35 0 .65-.1.88-.3.24-.2.36-.46.38-.77h1.34c-.02.4-.14.77-.37 1.1-.23.35-.54.62-.94.82-.4.2-.83.3-1.3.3-.87 0-1.58-.3-2.1-.86-.52-.58-.78-1.37-.78-2.38v-.15c0-.96.26-1.74.78-2.32.5-.57 1.22-.86 2.1-.86.76 0 1.38.22 1.85.66.48.44.72 1.02.75 1.73h-1.34c-.02-.36-.14-.66-.38-.9-.23-.23-.52-.34-.88-.34-.47 0-.82.15-1.07.5-.25.32-.38.83-.38 1.5v.24c0 .68.12 1.2.37 1.53.25.34.6.5 1.08.5zm6.46-6.85v1.54h1.12v1.05h-1.12v3.55c0 .25.04.42.14.53.1.1.27.16.5.16.18 0 .34-.02.5-.06v1.1c-.3.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8v-3.6h-1.04v-1.06h1.03v-1.54h1.43zm4.72 7.88h-1.43v-6.34h1.43V376zm-1.5-8c0-.2.06-.4.2-.53.13-.15.33-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.27 0-.47-.06-.6-.2-.14-.14-.2-.32-.2-.54zm6.28 6.2l1.34-4.54h1.48l-2.2 6.34h-1.24l-2.2-6.34h1.46l1.36 4.54zm7.42 1.92c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27v-.18c0-.63.13-1.2.37-1.7.25-.5.6-.88 1.04-1.16.44-.28.93-.42 1.47-.42.88 0 1.54.28 2.02.83.47.55.7 1.33.7 2.34v.58h-4.14c.04.52.22.94.52 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.17-5.43c-.38 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.72v-.1c-.04-.48-.16-.84-.4-1.1-.2-.23-.52-.35-.9-.35zm8.95 5.3v-8.53h2.93c.96 0 1.7.2 2.2.58.5.4.75.96.75 1.73 0 .4-.1.74-.3 1.05-.22.3-.53.56-.94.73.45.12.8.36 1.06.7.25.35.38.77.38 1.25 0 .8-.26 1.43-.77 1.86-.5.43-1.25.64-2.2.64h-3.12zm1.48-3.85v2.67h1.65c.47 0 .83-.12 1.1-.35.25-.23.38-.55.38-.96 0-.88-.45-1.33-1.36-1.35h-1.77zm0-1.1h1.46c.45 0 .8-.1 1.07-.3.26-.2.4-.5.4-.9s-.13-.72-.37-.9c-.24-.2-.62-.3-1.12-.3h-1.45v2.4zm8.47 4.95h-1.42v-9h1.42v9zm6.34 0c-.07-.12-.12-.32-.17-.6-.45.48-1 .72-1.66.72-.63 0-1.15-.18-1.55-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.22-.54 2.15-.54h.88v-.42c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.84-.3-.3 0-.58.1-.78.25-.2.16-.3.37-.3.62h-1.44c0-.36.12-.68.35-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.33-.26.74 0 1.33.2 1.77.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.46zm-1.57-1.03c.28 0 .55-.06.8-.2.24-.14.43-.32.56-.55v-1.2h-.77c-.53 0-.93.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.2.16.43.24.73.24zm5-2.2c0-.96.23-1.75.68-2.34.46-.6 1.07-.9 1.83-.9.67 0 1.2.25 1.63.72V367h1.43v9h-1.3l-.06-.66c-.43.52-1 .78-1.7.78-.75 0-1.35-.3-1.8-.9-.47-.6-.7-1.4-.7-2.44zm1.43.14c0 .65.12 1.15.37 1.52.25.36.6.54 1.06.54.58 0 1-.26 1.28-.78v-2.7c-.26-.52-.68-.77-1.26-.77-.46 0-.82.2-1.07.56-.25.36-.37.9-.37 1.65zm6.35-.12c0-.97.22-1.76.68-2.35.45-.6 1.06-.9 1.82-.9.67 0 1.22.25 1.63.72V367H184v9h-1.3l-.06-.66c-.42.52-1 .78-1.7.78-.74 0-1.34-.3-1.8-.9-.46-.6-.7-1.4-.7-2.44zm1.42.13c0 .65.13 1.15.37 1.52.25.36.6.54 1.06.54.58 0 1-.26 1.28-.78v-2.7c-.26-.52-.68-.77-1.27-.77-.45 0-.8.2-1.05.56-.25.36-.38.9-.38 1.65zm9.4 3.22c-.9 0-1.62-.3-2.18-.86-.57-.56-.85-1.32-.85-2.27v-.18c0-.63.12-1.2.36-1.7.26-.5.6-.88 1.04-1.16.44-.28.93-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.04.52.22.94.53 1.24.3.3.7.46 1.16.46.65 0 1.2-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.16-5.43c-.38 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.72v-.1c-.03-.48-.16-.84-.38-1.1-.23-.23-.54-.35-.93-.35zm8.15.26c-.2-.03-.38-.05-.58-.05-.66 0-1.1.26-1.32.76V376h-1.43v-6.34h1.36l.04.7c.34-.54.82-.82 1.43-.82.2 0 .37.03.5.08v1.34zm10.48 2.84c0-.37-.13-.66-.4-.86-.26-.2-.73-.4-1.42-.62-.68-.2-1.23-.44-1.63-.7-.78-.48-1.17-1.12-1.17-1.9 0-.7.28-1.26.84-1.7.56-.45 1.3-.67 2.2-.67.58 0 1.1.1 1.57.33.48.22.84.53 1.1.93.28.42.4.87.4 1.36h-1.47c0-.45-.14-.8-.42-1.05-.27-.24-.67-.36-1.2-.36-.47 0-.85.1-1.1.3-.28.2-.42.5-.42.87 0 .33.15.6.44.8.3.2.76.4 1.43.6.66.2 1.2.43 1.6.68.4.25.7.54.88.87.2.32.28.7.28 1.14 0 .7-.26 1.27-.8 1.7-.55.4-1.3.62-2.22.62-.62 0-1.2-.12-1.7-.35-.52-.22-.92-.54-1.2-.94-.3-.4-.44-.87-.44-1.4h1.48c0 .48.16.85.48 1.12.32.26.78.4 1.38.4.5 0 .9-.1 1.16-.32.26-.2.4-.48.4-.83zm5.86.16l1.28-4.3h1.52l-2.52 7.3c-.38 1.07-1.04 1.6-1.97 1.6-.2 0-.42-.03-.67-.1v-1.1h.27c.36 0 .63-.05.8-.2.2-.12.33-.34.44-.64l.2-.55-2.22-6.3h1.53l1.34 4.3zm5.94-4.3l.04.73c.47-.57 1.1-.86 1.85-.86 1.32 0 2 .76 2 2.27v4.2h-1.4v-4.1c0-.4-.1-.7-.27-.9-.18-.2-.46-.3-.85-.3-.57 0-1 .27-1.28.8v4.5h-1.42v-6.34h1.34zm6.1 3.12c0-.97.2-1.76.67-2.35.46-.6 1.07-.9 1.83-.9.67 0 1.2.25 1.63.72V367h1.42v9h-1.3l-.06-.66c-.42.52-1 .78-1.7.78-.75 0-1.35-.3-1.8-.9-.46-.6-.7-1.4-.7-2.44zm1.4.13c0 .65.13 1.15.38 1.52.25.36.6.54 1.06.54.58 0 1-.26 1.28-.78v-2.7c-.26-.52-.7-.77-1.27-.77-.47 0-.83.2-1.08.56-.25.36-.37.9-.37 1.65zm9.95-1.94c-.2-.03-.4-.05-.6-.05-.65 0-1.1.26-1.3.76V376h-1.44v-6.34h1.36l.04.7c.34-.54.82-.82 1.43-.82.2 0 .36.03.5.08v1.34zm1.4 1.8c0-.6.13-1.17.38-1.67.24-.5.6-.9 1.03-1.16.46-.26.97-.4 1.55-.4.85 0 1.55.28 2.08.83.53.55.82 1.28.87 2.2v.32c0 .62-.12 1.18-.36 1.67-.24.5-.58.87-1.03 1.14-.44.28-.95.42-1.54.42-.9 0-1.6-.3-2.15-.9-.52-.6-.8-1.4-.8-2.38v-.07zm1.43.13c0 .65.14 1.16.4 1.53.27.37.65.55 1.13.55.48 0 .85-.2 1.12-.56.27-.38.4-.93.4-1.65 0-.64-.13-1.15-.4-1.52-.28-.38-.66-.56-1.13-.56-.47 0-.84.17-1.1.54-.28.37-.42.92-.42 1.65zm8-3.24l.06.66c.43-.52 1.04-.78 1.8-.78.86 0 1.44.33 1.75.98.47-.65 1.1-.98 1.95-.98.7 0 1.22.2 1.56.58.34.4.52.96.53 1.7V376h-1.44v-4.13c0-.4-.1-.7-.26-.88-.18-.2-.47-.3-.88-.3-.32 0-.58.1-.8.27-.2.17-.34.4-.42.68V376h-1.42v-4.17c-.02-.75-.4-1.12-1.14-1.12-.57 0-.97.24-1.2.7v4.6h-1.44v-6.34h1.34zm12.9 6.46c-.9 0-1.62-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27v-.18c0-.63.13-1.2.37-1.7s.6-.88 1.03-1.16c.44-.28.93-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.04.52.22.94.52 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.44.2-.9.32-1.44.32zm-.16-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.72v-.1c-.04-.48-.16-.84-.38-1.1-.23-.23-.54-.35-.93-.35zM386.33 7.8c0-.37-.14-.66-.4-.86-.26-.2-.74-.4-1.43-.62-.68-.2-1.23-.44-1.64-.7-.77-.48-1.16-1.12-1.16-1.9 0-.7.28-1.26.84-1.7.56-.45 1.3-.67 2.18-.67.6 0 1.12.1 1.6.33.45.22.82.53 1.08.93.27.42.4.87.4 1.36h-1.47c0-.45-.14-.8-.42-1.05-.27-.24-.67-.36-1.2-.36-.48 0-.85.1-1.12.3-.27.2-.4.5-.4.87 0 .33.14.6.43.8.3.2.78.4 1.44.6.67.2 1.2.43 1.6.68.4.25.7.54.9.87.17.32.27.7.27 1.14 0 .7-.26 1.27-.8 1.7-.55.4-1.3.62-2.23.62-.6 0-1.18-.12-1.7-.35-.52-.22-.92-.54-1.2-.94-.3-.4-.44-.87-.44-1.4h1.5c0 .48.15.85.47 1.12.32.26.78.4 1.37.4.52 0 .9-.1 1.17-.32.26-.2.4-.48.4-.83zm6.43 2.32c-.9 0-1.63-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27V6.8c0-.63.12-1.2.36-1.7s.58-.88 1.02-1.16c.44-.28.94-.42 1.48-.42.86 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.14c.05.52.22.94.53 1.24.3.3.68.46 1.15.46.65 0 1.18-.26 1.6-.8l.76.74c-.25.38-.6.67-1 .88-.43.2-.9.32-1.44.32zm-.17-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.03-.48-.16-.84-.38-1.1-.22-.23-.53-.35-.93-.35zm7.1 1.05l1.2-2.1h1.58l-1.94 3.13 2 3.22h-1.57l-1.26-2.17-1.25 2.17h-1.6l2.02-3.22-1.94-3.12h1.57l1.2 2.1zm8.6 3.63c-.43.5-1.02.74-1.8.74-.68 0-1.2-.2-1.56-.6-.35-.4-.53-1-.53-1.75v-4.1h1.44v4.08c0 .8.33 1.2 1 1.2.7 0 1.16-.24 1.4-.74V3.67h1.42V10h-1.34l-.03-.62zm7.6.62c-.06-.12-.1-.32-.16-.6-.45.48-1 .72-1.67.72-.63 0-1.15-.18-1.55-.55-.4-.36-.6-.8-.6-1.35 0-.67.24-1.2.75-1.55.5-.36 1.2-.54 2.15-.54h.87V5.7c0-.32-.1-.58-.28-.78-.2-.2-.47-.3-.84-.3-.33 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.1-.68.34-1 .22-.3.54-.53.93-.7.4-.17.84-.26 1.33-.26.74 0 1.33.2 1.78.56.44.38.66.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.46zm-1.56-1.03c.28 0 .54-.06.8-.2.24-.14.43-.32.55-.55v-1.2h-.78c-.52 0-.92.1-1.2.28-.25.18-.38.44-.38.78 0 .27.1.5.27.65.2.16.43.24.74.24zm6.78 1.03h-1.42V1h1.42v9zm4.07 0h-1.44V1h1.43v9zm4.75-2.04l1.3-4.3h1.5l-2.5 7.3c-.4 1.07-1.05 1.6-1.98 1.6-.2 0-.43-.03-.68-.1v-1.1h.26c.35 0 .63-.05.8-.2.2-.12.33-.34.44-.64l.2-.55-2.22-6.3h1.53l1.35 4.3zm14.57-5.3h-2.66V10h-1.48V2.66h-2.63v-1.2h6.77v1.2zm4.92 2.3c-.2-.03-.4-.05-.58-.05-.66 0-1.1.26-1.32.76V10h-1.43V3.66h1.37l.04.7c.35-.54.83-.82 1.44-.82.2 0 .37.03.5.08v1.34zm5.5 5.04c-.06-.12-.1-.32-.16-.6-.45.48-1 .72-1.66.72-.64 0-1.16-.18-1.56-.55-.4-.36-.6-.8-.6-1.35 0-.67.25-1.2.75-1.55.5-.36 1.23-.54 2.16-.54h.88V5.7c0-.32-.1-.58-.28-.78-.18-.2-.46-.3-.84-.3-.32 0-.6.1-.8.25-.2.16-.3.37-.3.62h-1.43c0-.36.1-.68.34-1 .23-.3.54-.53.94-.7.4-.17.84-.26 1.33-.26.75 0 1.34.2 1.78.56.44.38.67.9.68 1.58v2.86c0 .57.08 1.02.24 1.36v.1h-1.45zm-1.56-1.03c.28 0 .55-.06.8-.2.24-.14.43-.32.56-.55v-1.2h-.77c-.53 0-.93.1-1.2.28-.26.18-.4.44-.4.78 0 .27.1.5.28.65.18.16.43.24.73.24zm6.6-5.3l.03.72c.48-.57 1.1-.86 1.86-.86 1.32 0 2 .76 2 2.27V10h-1.4V5.9c0-.4-.1-.7-.27-.9-.18-.2-.47-.3-.86-.3-.58 0-1 .27-1.3.8V10h-1.4V3.66h1.33zm9.9 4.6c0-.25-.1-.44-.3-.57-.22-.14-.57-.25-1.05-.35-.5-.1-.9-.23-1.22-.4-.7-.33-1.05-.83-1.05-1.5 0-.53.23-1 .7-1.36.45-.37 1.03-.56 1.75-.56.75 0 1.37.2 1.83.57.47.38.7.87.7 1.46h-1.42c0-.27-.1-.5-.3-.68-.2-.18-.47-.27-.8-.27-.32 0-.57.08-.77.23-.2.14-.3.33-.3.58 0 .23.1.4.28.52.2.12.56.24 1.12.36.56.13 1 .27 1.32.44.32.17.55.38.7.6.16.25.24.54.24.88 0 .57-.24 1.03-.7 1.4-.48.34-1.1.52-1.87.52-.5 0-.97-.1-1.38-.28-.4-.2-.72-.45-.94-.78-.23-.33-.34-.68-.34-1.06h1.38c.02.34.14.6.38.78.23.18.54.27.93.27.38 0 .66-.07.86-.2.18-.16.28-.34.28-.57zm4.98-4.6l.04.65c.44-.52 1.05-.78 1.83-.78.84 0 1.42.33 1.74.98.46-.65 1.1-.98 1.94-.98.7 0 1.23.2 1.57.58.35.4.52.96.53 1.7V10h-1.43V5.87c0-.4-.08-.7-.26-.88-.17-.2-.46-.3-.86-.3-.33 0-.6.1-.8.27-.2.17-.35.4-.43.68l.02 4.35h-1.43V5.83c-.02-.75-.4-1.12-1.15-1.12-.57 0-.97.24-1.2.7V10h-1.43V3.66h1.34zm11.6 6.33h-1.4V3.66h1.4V10zm-1.5-8c0-.2.07-.4.2-.53.15-.15.35-.22.6-.22.26 0 .46.07.6.22.14.14.2.32.2.54 0 .23-.06.4-.2.55-.14.14-.34.2-.6.2-.25 0-.45-.06-.6-.2-.13-.14-.2-.32-.2-.54zm5.85.12v1.54h1.13V4.7h-1.12v3.55c0 .25.06.42.15.53.1.1.27.16.5.16.18 0 .34-.02.5-.06v1.1c-.3.1-.62.14-.92.14-1.1 0-1.65-.6-1.65-1.8V4.7h-1.04V3.65h1.04V2.12h1.43zm5 0v1.54h1.12V4.7h-1.12v3.55c0 .25.05.42.14.53.1.1.27.16.52.16.16 0 .33-.02.5-.06v1.1c-.33.1-.64.14-.94.14-1.1 0-1.64-.6-1.64-1.8V4.7h-1.05V3.65h1.05V2.12h1.42zm6 8c-.9 0-1.64-.3-2.2-.86-.56-.56-.84-1.32-.84-2.27V6.8c0-.63.12-1.2.37-1.7.24-.5.58-.88 1.03-1.16.44-.28.93-.42 1.47-.42.87 0 1.53.28 2 .83.47.55.7 1.33.7 2.34v.58h-4.13c.04.52.22.94.52 1.24.3.3.7.46 1.16.46.65 0 1.18-.26 1.6-.8l.76.74c-.25.38-.6.67-1.02.88-.42.2-.9.32-1.42.32zm-.17-5.43c-.4 0-.7.12-.95.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.14-.84-.37-1.1-.22-.23-.53-.35-.92-.35zm4.55 2.08c0-.97.22-1.76.68-2.35.45-.6 1.06-.9 1.82-.9.67 0 1.2.25 1.63.72V1h1.43v9h-1.3l-.06-.66c-.42.52-1 .78-1.7.78-.74 0-1.34-.3-1.8-.9-.46-.6-.7-1.4-.7-2.44zm1.42.13c0 .65.13 1.15.37 1.52.25.36.6.54 1.06.54.58 0 1-.26 1.28-.78v-2.7c-.25-.52-.67-.77-1.26-.77-.46 0-.8.2-1.06.56-.25.36-.38.9-.38 1.65zm12.3 3.1h-1.47V1.47h1.48V10zm4-6.34l.06.73c.46-.57 1.08-.86 1.84-.86 1.32 0 2 .76 2.02 2.27V10h-1.43V5.9c0-.4-.1-.7-.27-.9-.17-.2-.46-.3-.85-.3-.57 0-1 .27-1.28.8V10h-1.43V3.66h1.34zm6.87 6.34V4.7h-.97V3.67h.97v-.58c0-.7.2-1.25.58-1.63.4-.38.94-.57 1.64-.57.24 0 .5.03.8.1l-.04 1.12c-.16-.04-.34-.05-.55-.05-.67 0-1 .35-1 1.05v.56h1.28V4.7h-1.3V10h-1.4zm7.4.12c-.9 0-1.63-.3-2.2-.86-.55-.56-.83-1.32-.83-2.27V6.8c0-.63.12-1.2.36-1.7.25-.5.6-.88 1.03-1.16.44-.28.93-.42 1.48-.42.87 0 1.54.28 2 .83.48.55.7 1.33.7 2.34v.58h-4.13c.05.52.22.94.53 1.24.3.3.7.46 1.15.46.66 0 1.2-.26 1.6-.8l.77.74c-.26.38-.6.67-1.02.88-.43.2-.9.32-1.43.32zM538 4.7c-.4 0-.7.12-.94.4-.24.27-.4.65-.46 1.14h2.7v-.1c-.02-.48-.15-.84-.37-1.1-.22-.23-.53-.35-.93-.35zm7.42 4.28c.36 0 .65-.1.9-.3.22-.22.35-.47.36-.78h1.35c-.02.4-.14.77-.37 1.1-.23.35-.55.62-.94.82-.4.2-.82.3-1.28.3-.9 0-1.6-.3-2.1-.86-.53-.58-.8-1.37-.8-2.38v-.15c0-.96.27-1.74.8-2.32.5-.57 1.2-.86 2.1-.86.75 0 1.36.22 1.84.66.47.44.72 1.02.75 1.73h-1.35c0-.36-.14-.66-.37-.9-.22-.23-.52-.34-.88-.34-.46 0-.8.15-1.06.5-.25.32-.38.83-.38 1.5v.24c0 .68.12 1.2.37 1.53.25.34.6.5 1.07.5zm6.46-6.86v1.54H553V4.7h-1.12v3.55c0 .25.05.42.15.53.1.1.26.16.5.16.18 0 .34-.02.5-.06v1.1c-.32.1-.63.14-.93.14-1.1 0-1.64-.6-1.64-1.8V4.7h-1.04V3.65h1.04V2.12h1.42zM556.6 10h-1.42V3.66h1.43V10zm-1.5-8c0-.2.06-.4.2-.53.14-.15.34-.22.6-.22.25 0 .45.07.6.22.13.14.2.32.2.54 0 .23-.07.4-.2.55-.15.14-.35.2-.6.2-.26 0-.46-.06-.6-.2-.14-.14-.2-.32-.2-.54zm3.8 4.77c0-.62.1-1.18.36-1.68.24-.5.6-.9 1.03-1.16.44-.26.95-.4 1.53-.4.86 0 1.55.28 2.08.83.55.55.83 1.28.88 2.2v.32c0 .62-.12 1.18-.36 1.67-.24.5-.58.87-1.03 1.14-.46.28-.97.42-1.56.42-.9 0-1.6-.3-2.15-.9-.54-.6-.8-1.4-.8-2.38v-.07zm1.4.12c0 .65.15 1.16.42 1.53.27.37.64.55 1.12.55.48 0 .86-.2 1.12-.56.27-.38.4-.93.4-1.65 0-.64-.13-1.15-.4-1.52-.28-.38-.66-.56-1.13-.56-.46 0-.83.17-1.1.54-.28.37-.42.92-.42 1.65zm8-3.24l.05.73c.47-.57 1.08-.86 1.85-.86 1.32 0 2 .76 2 2.27V10h-1.4V5.9c0-.4-.1-.7-.27-.9-.18-.2-.46-.3-.86-.3-.57 0-1 .27-1.28.8V10h-1.43V3.66h1.34zm9.9 4.62c0-.26-.1-.45-.3-.58-.2-.14-.55-.25-1.04-.35-.48-.1-.9-.23-1.2-.4-.72-.33-1.08-.83-1.08-1.5 0-.53.23-1 .7-1.36.45-.37 1.04-.56 1.75-.56.76 0 1.37.2 1.84.57.46.38.7.87.7 1.46h-1.43c0-.27-.1-.5-.3-.68-.2-.18-.47-.27-.8-.27-.32 0-.58.08-.77.23-.2.14-.3.33-.3.58 0 .23.1.4.28.52.18.12.55.24 1.1.36.57.13 1 .27 1.32.44.32.17.56.38.7.6.17.25.25.54.25.88 0 .57-.24 1.03-.7 1.4-.5.34-1.1.52-1.87.52-.52 0-.98-.1-1.4-.28-.4-.2-.7-.45-.94-.78-.22-.33-.33-.68-.33-1.06h1.38c.02.34.15.6.38.78.24.18.55.27.94.27.37 0 .66-.07.85-.2.2-.16.3-.34.3-.57z"/>
          </g>
        </svg>
      </div>
      <div
        data-depth="0.20"
        className="layer layer-1">
        <svg
          id="player-layer-1"
          x="0px"
          y="0px"
          viewBox="0 0 1546.2 893.8">
          <g className="st0">
            <line
              className="st1"
              x1="1027.6"
              y1="754"
              x2="1106.4"
              y2="708.5"/>
            <ellipse
              transform="matrix(0.5 -0.866 0.866 0.5 -58.3277 1312.3447)"
              className="st2"
              cx="1107.4"
              cy="706.7"
              rx="10.6"
              ry="10.6"/>
            <line
              className="st1"
              x1="944.3"
              y1="708.8"
              x2="1023.1"
              y2="754.3"/>
            <circle
              className="st2"
              cx="1025.3"
              cy="754.3"
              r="10.6"/>
            <g>
              <line
                className="st1"
                x1="1253.1"
                y1="464.4"
                x2="1253.1"
                y2="418.9"/>
              <line
                className="st1"
                x1="1253.1"
                y1="418.9"
                x2="1292.5"
                y2="396.1"/>
              <line
                className="st1"
                x1="1331.9"
                y1="464.4"
                x2="1331.9"
                y2="418.9"/>
              <line
                className="st1"
                x1="1331.9"
                y1="418.9"
                x2="1292.5"
                y2="396.1"/>
              <line
                className="st1"
                x1="1331.9"
                y1="464.4"
                x2="1292.5"
                y2="487.1"/>
              <line
                className="st1"
                x1="1253.1"
                y1="464.4"
                x2="1292.5"
                y2="487.1"/>
            </g>
            <line
              className="st1"
              x1="1321.3"
              y1="456.8"
              x2="1321.3"
              y2="426.4"/>
            <line
              className="st1"
              x1="1265"
              y1="424.3"
              x2="1291.2"
              y2="409.1"/>
            <line
              className="st1"
              x1="1265"
              y1="459"
              x2="1291.2"
              y2="474.1"/>
            <g>
              <line
                className="st1"
                x1="1331.9"
                y1="464.4"
                x2="1331.9"
                y2="418.9"/>
              <line
                className="st1"
                x1="1331.9"
                y1="418.9"
                x2="1371.3"
                y2="396.1"/>
              <line
                className="st1"
                x1="1410.7"
                y1="464.4"
                x2="1410.7"
                y2="418.9"/>
              <line
                className="st1"
                x1="1410.7"
                y1="418.9"
                x2="1371.3"
                y2="396.1"/>
              <line
                className="st1"
                x1="1410.7"
                y1="464.4"
                x2="1371.3"
                y2="487.1"/>
              <line
                className="st1"
                x1="1331.9"
                y1="464.4"
                x2="1371.3"
                y2="487.1"/>
            </g>
            <line
              className="st1"
              x1="1372.6"
              y1="474.1"
              x2="1398.8"
              y2="459"/>
            <line
              className="st1"
              x1="1291.2"
              y1="517.5"
              x2="1291.2"
              y2="487.1"/>
            <line
              className="st1"
              x1="1251.8"
              y1="542.3"
              x2="1291.2"
              y2="519.6"/>
            <line
              className="st1"
              x1="1330.6"
              y1="542.3"
              x2="1291.2"
              y2="519.6"/>
            <line
              className="st1"
              x1="1252.6"
              y1="418.9"
              x2="1226.3"
              y2="403.7"/>
            <line
              className="st1"
              x1="1410.7"
              y1="418.9"
              x2="1437"
              y2="403.7"/>
            <line
              className="st1"
              x1="1112.2"
              y1="324"
              x2="1112.2"
              y2="278.5"/>
            <line
              className="st1"
              x1="1112.2"
              y1="324"
              x2="1072.8"
              y2="346.8"/>
            <line
              className="st1"
              x1="1112.2"
              y1="324"
              x2="1151.6"
              y2="346.8"/>
            <circle
              className="st2"
              cx="1151.6"
              cy="346.8"
              r="10.6"/>
            <circle
              className="st2"
              cx="1112.2"
              cy="278.5"
              r="10.6"/>
            <circle
              className="st2"
              cx="1072.8"
              cy="346.8"
              r="10.6"/>
            <line
              className="st1"
              x1="867.4"
              y1="184.5"
              x2="821.9"
              y2="263.3"/>
            <line
              className="st1"
              x1="867.4"
              y1="184.5"
              x2="958.5"
              y2="184.5"/>
            <line
              className="st1"
              x1="867.4"
              y1="184.5"
              x2="821.9"
              y2="105.7"/>
            <circle
              className="st2"
              cx="867.4"
              cy="184.5"
              r="31.9"/>
            <circle
              className="st2"
              cx="821.9"
              cy="265.5"
              r="10.6"/>
            <circle
              className="st2"
              cx="958.5"
              cy="184.5"
              r="10.6"/>
            <line
              className="st1"
              x1="782.5"
              y1="84.2"
              x2="782.5"
              y2="38.7"/>
            <line
              className="st1"
              x1="782.5"
              y1="84.2"
              x2="743.1"
              y2="107"/>
            <line
              className="st1"
              x1="782.5"
              y1="84.2"
              x2="821.9"
              y2="107"/>
            <circle
              className="st2"
              cx="821.9"
              cy="107"
              r="10.6"/>
            <circle
              className="st2"
              cx="782.5"
              cy="38.7"
              r="10.6"/>
            <circle
              className="st2"
              cx="743.1"
              cy="107"
              r="10.6"/>
            <line
              className="st1"
              x1="394.2"
              y1="505.9"
              x2="473"
              y2="460.4"/>
            <line
              className="st1"
              x1="394.2"
              y1="505.9"
              x2="315.3"
              y2="460.4"/>
            <ellipse
              transform="matrix(0.5 -0.866 0.866 0.5 -241.0497 594.2597)"
              className="st2"
              cx="394.1"
              cy="505.9"
              rx="31.9"
              ry="31.9"/>
            <ellipse
              transform="matrix(0.5 -0.866 0.866 0.5 -160.1837 639.821)"
              className="st2"
              cx="474"
              cy="458.6"
              rx="10.6"
              ry="10.6"/>
            <line
              className="st1"
              x1="315.3"
              y1="413.5"
              x2="354.7"
              y2="390.8"/>
            <line
              className="st1"
              x1="315.3"
              y1="413.5"
              x2="275.9"
              y2="390.8"/>
            <line
              className="st1"
              x1="315.3"
              y1="413.5"
              x2="315.3"
              y2="459"/>
            <ellipse
              transform="matrix(0.866 -0.5 0.5 0.866 -187.2653 219.1478)"
              className="st2"
              cx="315.3"
              cy="459"
              rx="10.6"
              ry="10.6"/>
            <ellipse
              transform="matrix(0.866 -0.5 0.5 0.866 -147.881 229.7246)"
              className="st2"
              cx="354.7"
              cy="390.8"
              rx="10.6"
              ry="10.6"/>
            <ellipse
              transform="matrix(0.866 -0.5 0.5 0.866 -158.4348 190.3226)"
              className="st2"
              cx="275.9"
              cy="390.8"
              rx="10.6"
              ry="10.6"/>
            <g>
              <line
                className="st1"
                x1="465.5"
                y1="763.9"
                x2="465.5"
                y2="718.4"/>
              <line
                className="st1"
                x1="465.5"
                y1="718.4"
                x2="504.9"
                y2="695.7"/>
              <line
                className="st1"
                x1="544.3"
                y1="763.9"
                x2="544.3"
                y2="718.4"/>
              <line
                className="st1"
                x1="544.3"
                y1="718.4"
                x2="504.9"
                y2="695.7"/>
              <line
                className="st1"
                x1="544.3"
                y1="763.9"
                x2="504.9"
                y2="786.7"/>
              <line
                className="st1"
                x1="465.5"
                y1="763.9"
                x2="504.9"
                y2="786.7"/>
            </g>
            <line
              className="st1"
              x1="506.2"
              y1="773.7"
              x2="532.4"
              y2="758.5"/>
            <line
              className="st1"
              x1="465.5"
              y1="718.4"
              x2="439.2"
              y2="703.3"/>
            <line
              className="st1"
              x1="439.2"
              y1="703.3"
              x2="439.2"
              y2="657.8"/>
            <line
              className="st1"
              x1="449.8"
              y1="695.7"
              x2="449.8"
              y2="665.4"/>
            <line
              className="st1"
              x1="544.3"
              y1="763.7"
              x2="583.7"
              y2="786.5"/>
            <g>
              <line
                className="st1"
                x1="595"
                y1="218.9"
                x2="572.3"
                y2="258.4"/>
              <line
                className="st1"
                x1="572.3"
                y1="258.4"
                x2="526.8"
                y2="258.4"/>
              <line
                className="st1"
                x1="526.8"
                y1="179.5"
                x2="504"
                y2="218.9"/>
              <line
                className="st1"
                x1="504"
                y1="218.9"
                x2="526.8"
                y2="258.4"/>
              <line
                className="st1"
                x1="526.8"
                y1="179.5"
                x2="572.3"
                y2="179.5"/>
              <line
                className="st1"
                x1="595"
                y1="218.9"
                x2="572.3"
                y2="179.5"/>
            </g>
            <line
              className="st1"
              x1="564.7"
              y1="190.2"
              x2="534.4"
              y2="190.2"/>
            <line
              className="st1"
              x1="532.2"
              y1="246.5"
              x2="517"
              y2="220.2"/>
            <g>
              <line
                className="st1"
                x1="629.2"
                y1="317.5"
                x2="617.8"
                y2="337.2"/>
              <line
                className="st1"
                x1="617.8"
                y1="337.2"
                x2="595"
                y2="337.2"/>
              <line
                className="st1"
                x1="595"
                y1="297.8"
                x2="583.7"
                y2="317.5"/>
              <line
                className="st1"
                x1="583.7"
                y1="317.5"
                x2="595"
                y2="337.2"/>
              <line
                className="st1"
                x1="595"
                y1="297.8"
                x2="617.8"
                y2="297.8"/>
              <line
                className="st1"
                x1="629.2"
                y1="317.5"
                x2="617.8"
                y2="297.8"/>
            </g>
            <line
              className="st1"
              x1="595"
              y1="297.8"
              x2="572.3"
              y2="258.4"/>
            <line
              className="st1"
              x1="600"
              y1="285.9"
              x2="584.8"
              y2="259.7"/>
            <line
              className="st1"
              x1="596.2"
              y1="140.1"
              x2="573.4"
              y2="179.5"/>
            <line
              className="st1"
              x1="504"
              y1="218.9"
              x2="473.7"
              y2="218.9"/>
            <g>
              <line
                className="st1"
                x1="186.5"
                y1="657.8"
                x2="186.5"
                y2="612.3"/>
              <line
                className="st1"
                x1="186.5"
                y1="612.3"
                x2="225.9"
                y2="589.5"/>
              <line
                className="st1"
                x1="265.3"
                y1="657.8"
                x2="265.3"
                y2="612.3"/>
              <line
                className="st1"
                x1="265.3"
                y1="612.3"
                x2="225.9"
                y2="589.5"/>
              <line
                className="st1"
                x1="265.3"
                y1="657.8"
                x2="225.9"
                y2="680.5"/>
              <line
                className="st1"
                x1="186.5"
                y1="657.8"
                x2="225.9"
                y2="680.5"/>
            </g>
            <line
              className="st1"
              x1="197.1"
              y1="650.2"
              x2="197.1"
              y2="619.8"/>
            <line
              className="st1"
              x1="227.2"
              y1="602.5"
              x2="253.4"
              y2="617.7"/>
            <line
              className="st1"
              x1="265.3"
              y1="656.6"
              x2="304.7"
              y2="679.3"/>
            <circle
              className="st2"
              cx="304.7"
              cy="679.3"
              r="10.6"/>
            <g>
              <line
                className="st1"
                x1="103.9"
                y1="657.8"
                x2="103.9"
                y2="612.3"/>
              <line
                className="st1"
                x1="103.9"
                y1="612.3"
                x2="143.3"
                y2="589.5"/>
              <line
                className="st1"
                x1="182.7"
                y1="657.8"
                x2="182.7"
                y2="612.3"/>
              <line
                className="st1"
                x1="182.7"
                y1="612.3"
                x2="143.3"
                y2="589.5"/>
              <line
                className="st1"
                x1="182.7"
                y1="657.8"
                x2="143.3"
                y2="680.5"/>
              <line
                className="st1"
                x1="103.9"
                y1="657.8"
                x2="143.3"
                y2="680.5"/>
            </g>
            <line
              className="st1"
              x1="144.5"
              y1="667.5"
              x2="170.8"
              y2="652.4"/>
            <g>
              <line
                className="st1"
                x1="1331.9"
                y1="464.4"
                x2="1331.9"
                y2="418.9"/>
              <line
                className="st1"
                x1="1331.9"
                y1="418.9"
                x2="1371.3"
                y2="396.1"/>
              <line
                className="st1"
                x1="1410.7"
                y1="464.4"
                x2="1410.7"
                y2="418.9"/>
              <line
                className="st1"
                x1="1410.7"
                y1="418.9"
                x2="1371.3"
                y2="396.1"/>
              <line
                className="st1"
                x1="1410.7"
                y1="464.4"
                x2="1371.3"
                y2="487.1"/>
              <line
                className="st1"
                x1="1331.9"
                y1="464.4"
                x2="1371.3"
                y2="487.1"/>
            </g>
            <line
              className="st1"
              x1="1372.6"
              y1="474.1"
              x2="1398.8"
              y2="459"/>
            <line
              className="st1"
              x1="103.9"
              y1="597.1"
              x2="130.1"
              y2="581.9"/>
            <line
              className="st1"
              x1="919"
              y1="731.2"
              x2="879.6"
              y2="754"/>
            <line
              className="st1"
              x1="879.6"
              y1="797.1"
              x2="879.6"
              y2="751.6"/>
            <line
              className="st1"
              x1="879.6"
              y1="797.1"
              x2="840.2"
              y2="819.8"/>
            <line
              className="st1"
              x1="879.6"
              y1="797.1"
              x2="919"
              y2="819.8"/>
            <circle
              className="st2"
              cx="879.6"
              cy="751.6"
              r="10.6"/>
            <circle
              className="st2"
              cx="840.2"
              cy="819.8"
              r="10.6"/>
            <line
              className="st1"
              x1="893.8"
              y1="793.3"
              x2="920"
              y2="808.4"/>
            <line
              className="st1"
              x1="990.9"
              y1="634.3"
              x2="945.4"
              y2="713.1"/>
            <line
              className="st1"
              x1="990.9"
              y1="634.3"
              x2="1081.9"
              y2="634.3"/>
            <circle
              className="st2"
              cx="990.9"
              cy="634.3"
              r="31.9"/>
            <circle
              className="st2"
              cx="1081.9"
              cy="634.3"
              r="10.6"/>
            <ellipse
              transform="matrix(0.5 -0.866 0.866 0.5 -141.7717 1176.3046)"
              className="st2"
              cx="947.8"
              cy="710.9"
              rx="31.9"
              ry="31.9"/>
            <circle
              className="st2"
              cx="1239.4"
              cy="773.7"
              r="10.6"/>
            <circle
              className="st2"
              cx="354.7"
              cy="819.8"
              r="10.6"/>
            <circle
              className="st2"
              cx="979.7"
              cy="301.3"
              r="10.6"/>
            <line
              className="st1"
              x1="1251.8"
              y1="283.7"
              x2="1278.1"
              y2="268.5"/>
            <line
              className="st1"
              x1="695.7"
              y1="697.5"
              x2="722"
              y2="682.4"/>
            <line
              className="st1"
              x1="223.3"
              y1="509.9"
              x2="249.6"
              y2="494.7"/>
            <line
              className="st1"
              x1="391.5"
              y1="283.7"
              x2="417.8"
              y2="268.5"/>
            <line
              className="st1"
              x1="1094.3"
              y1="530.2"
              x2="1120.6"
              y2="545.4"/>
            <line
              className="st1"
              x1="702.9"
              y1="182.6"
              x2="729.2"
              y2="197.7"/>
            <line
              className="st1"
              x1="173.4"
              y1="545.4"
              x2="199.6"
              y2="560.6"/>
            <line
              className="st1"
              x1="719.4"
              y1="877.6"
              x2="745.6"
              y2="892.8"/>
            <g>
              <line
                className="st1"
                x1="695.7"
                y1="830.4"
                x2="690.1"
                y2="840.3"/>
              <line
                className="st1"
                x1="690.1"
                y1="840.3"
                x2="678.7"
                y2="840.3"/>
              <line
                className="st1"
                x1="678.7"
                y1="820.6"
                x2="673"
                y2="830.4"/>
              <line
                className="st1"
                x1="673"
                y1="830.4"
                x2="678.7"
                y2="840.3"/>
              <line
                className="st1"
                x1="678.7"
                y1="820.6"
                x2="690.1"
                y2="820.6"/>
              <line
                className="st1"
                x1="695.7"
                y1="830.4"
                x2="690.1"
                y2="820.6"/>
            </g>
            <g>
              <line
                className="st1"
                x1="1134.2"
                y1="152.7"
                x2="1128.5"
                y2="162.5"/>
              <line
                className="st1"
                x1="1128.5"
                y1="162.5"
                x2="1117.2"
                y2="162.5"/>
              <line
                className="st1"
                x1="1117.2"
                y1="142.8"
                x2="1111.5"
                y2="152.7"/>
              <line
                className="st1"
                x1="1111.5"
                y1="152.7"
                x2="1117.2"
                y2="162.5"/>
              <line
                className="st1"
                x1="1117.2"
                y1="142.8"
                x2="1128.5"
                y2="142.8"/>
              <line
                className="st1"
                x1="1134.2"
                y1="152.7"
                x2="1128.5"
                y2="142.8"/>
            </g>
            <g>
              <line
                className="st1"
                x1="103.9"
                y1="441.6"
                x2="98.2"
                y2="451.5"/>
              <line
                className="st1"
                x1="98.2"
                y1="451.5"
                x2="86.8"
                y2="451.5"/>
              <line
                className="st1"
                x1="86.8"
                y1="431.8"
                x2="81.1"
                y2="441.6"/>
              <line
                className="st1"
                x1="81.1"
                y1="441.6"
                x2="86.8"
                y2="451.5"/>
              <line
                className="st1"
                x1="86.8"
                y1="431.8"
                x2="98.2"
                y2="431.8"/>
              <line
                className="st1"
                x1="103.9"
                y1="441.6"
                x2="98.2"
                y2="431.8"/>
            </g>
            <g>
              <line
                className="st1"
                x1="307"
                y1="157.6"
                x2="301.3"
                y2="167.4"/>
              <line
                className="st1"
                x1="301.3"
                y1="167.4"
                x2="289.9"
                y2="167.4"/>
              <line
                className="st1"
                x1="289.9"
                y1="147.7"
                x2="284.3"
                y2="157.6"/>
              <line
                className="st1"
                x1="284.3"
                y1="157.6"
                x2="289.9"
                y2="167.4"/>
              <line
                className="st1"
                x1="289.9"
                y1="147.7"
                x2="301.3"
                y2="147.7"/>
              <line
                className="st1"
                x1="307"
                y1="157.6"
                x2="301.3"
                y2="147.7"/>
            </g>
            <line
              className="st1"
              x1="1423.9"
              y1="589.5"
              x2="1423.9"
              y2="559.2"/>
            <line
              className="st1"
              x1="433.6"
              y1="120.9"
              x2="433.6"
              y2="90.5"/>
            <line
              className="st1"
              x1="234.5"
              y1="832.9"
              x2="313.3"
              y2="787.4"/>
            <ellipse
              transform="matrix(0.5 -0.866 0.866 0.5 -604.0362 619.4732)"
              className="st2"
              cx="234.5"
              cy="832.9"
              rx="31.9"
              ry="31.9"/>
            <ellipse
              transform="matrix(0.5 -0.866 0.866 0.5 -523.1701 664.9343)"
              className="st2"
              cx="314.3"
              cy="785.6"
              rx="10.6"
              ry="10.6"/>
            <g>
              <line
                className="st1"
                x1="104.9"
                y1="328.1"
                x2="104.9"
                y2="373.6"/>
              <line
                className="st1"
                x1="104.9"
                y1="373.6"
                x2="65.5"
                y2="396.4"/>
              <line
                className="st1"
                x1="26"
                y1="328.1"
                x2="26"
                y2="373.6"/>
              <line
                className="st1"
                x1="26"
                y1="373.6"
                x2="65.5"
                y2="396.4"/>
              <line
                className="st1"
                x1="26"
                y1="328.1"
                x2="65.5"
                y2="305.4"/>
              <line
                className="st1"
                x1="104.9"
                y1="328.1"
                x2="65.5"
                y2="305.4"/>
            </g>
            <line
              className="st1"
              x1="27.3"
              y1="372.5"
              x2="1"
              y2="387.7"/>
            <g>
              <line
                className="st1"
                x1="209.9"
                y1="266.2"
                x2="209.9"
                y2="311.7"/>
              <line
                className="st1"
                x1="209.9"
                y1="311.7"
                x2="170.5"
                y2="334.5"/>
              <line
                className="st1"
                x1="131.1"
                y1="266.2"
                x2="131.1"
                y2="311.7"/>
              <line
                className="st1"
                x1="131.1"
                y1="311.7"
                x2="170.5"
                y2="334.5"/>
              <line
                className="st1"
                x1="131.1"
                y1="266.2"
                x2="170.5"
                y2="243.5"/>
              <line
                className="st1"
                x1="209.9"
                y1="266.2"
                x2="170.5"
                y2="243.5"/>
            </g>
            <line
              className="st1"
              x1="169.3"
              y1="256.5"
              x2="143"
              y2="271.6"/>
            <line
              className="st1"
              x1="130.6"
              y1="145.1"
              x2="130.6"
              y2="175.4"/>
            <line
              className="st1"
              x1="91.2"
              y1="196.5"
              x2="51.8"
              y2="173.7"/>
            <line
              className="st1"
              x1="570.5"
              y1="405.9"
              x2="596.8"
              y2="421.1"/>
            <line
              className="st1"
              x1="131.1"
              y1="311.7"
              x2="104.9"
              y2="326.9"/>
            <g>
              <line
                className="st1"
                x1="209.9"
                y1="266.2"
                x2="209.9"
                y2="311.7"/>
              <line
                className="st1"
                x1="209.9"
                y1="311.7"
                x2="170.5"
                y2="334.5"/>
              <line
                className="st1"
                x1="131.1"
                y1="266.2"
                x2="131.1"
                y2="311.7"/>
              <line
                className="st1"
                x1="131.1"
                y1="311.7"
                x2="170.5"
                y2="334.5"/>
              <line
                className="st1"
                x1="131.1"
                y1="266.2"
                x2="170.5"
                y2="243.5"/>
              <line
                className="st1"
                x1="209.9"
                y1="266.2"
                x2="170.5"
                y2="243.5"/>
            </g>
            <g>
              <line
                className="st1"
                x1="170"
                y1="196.5"
                x2="170"
                y2="242"/>
              <line
                className="st1"
                x1="170"
                y1="242"
                x2="130.6"
                y2="264.7"/>
              <line
                className="st1"
                x1="91.2"
                y1="196.5"
                x2="91.2"
                y2="242"/>
              <line
                className="st1"
                x1="91.2"
                y1="242"
                x2="130.6"
                y2="264.7"/>
              <line
                className="st1"
                x1="91.2"
                y1="196.5"
                x2="130.6"
                y2="173.7"/>
              <line
                className="st1"
                x1="170"
                y1="196.5"
                x2="130.6"
                y2="173.7"/>
            </g>
            <g>
              <line
                className="st1"
                x1="110.9"
                y1="112"
                x2="130.6"
                y2="100.6"/>
              <line
                className="st1"
                x1="130.6"
                y1="100.6"
                x2="150.3"
                y2="112"/>
              <line
                className="st1"
                x1="130.6"
                y1="146.2"
                x2="150.3"
                y2="134.8"/>
              <line
                className="st1"
                x1="150.3"
                y1="134.8"
                x2="150.3"
                y2="112"/>
              <line
                className="st1"
                x1="130.6"
                y1="146.2"
                x2="110.9"
                y2="134.8"/>
              <line
                className="st1"
                x1="110.9"
                y1="112"
                x2="110.9"
                y2="134.8"/>
            </g>
            <line
              className="st1"
              x1="1345.4"
              y1="687.3"
              x2="1385.8"
              y2="708.2"/>

            <ellipse
              transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -30.4953 63.1829)"
              className="st2"
              cx="1343.3"
              cy="687.3"
              rx="10.6"
              ry="10.6"/>
            <line
              className="st1"
              x1="1414.9"
              y1="833.3"
              x2="1414.9"
              y2="721"/>
            <line
              className="st1"
              x1="1414.9"
              y1="721"
              x2="1534.6"
              y2="651.9"/>
            <line
              className="st1"
              x1="1414.9"
              y1="722.2"
              x2="1313.1"
              y2="781"/>
            <circle
              className="st2"
              cx="1414.9"
              cy="721"
              r="31.9"/>

            <ellipse
              transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -28.6433 72.0366)"
              className="st2"
              cx="1534.6"
              cy="651.9"
              rx="10.6"
              ry="10.6"/>

            <ellipse
              transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -37.2046 66.6688)"
              className="st2"
              cx="1414.9"
              cy="833.3"
              rx="10.6"
              ry="10.6"/>

            <ellipse
              transform="matrix(0.9989 -4.648339e-02 4.648339e-02 0.9989 -34.8834 61.8803)"
              className="st2"
              cx="1313.1"
              cy="781"
              rx="10.6"
              ry="10.6"/>
            <g>
              <line
                className="st1"
                x1="1212.4"
                y1="190.2"
                x2="1212.4"
                y2="144.7"/>
              <line
                className="st1"
                x1="1212.4"
                y1="144.7"
                x2="1251.8"
                y2="121.9"/>
              <line
                className="st1"
                x1="1291.2"
                y1="190.2"
                x2="1291.2"
                y2="144.7"/>
              <line
                className="st1"
                x1="1291.2"
                y1="144.7"
                x2="1251.8"
                y2="121.9"/>
              <line
                className="st1"
                x1="1291.2"
                y1="190.2"
                x2="1251.8"
                y2="212.9"/>
              <line
                className="st1"
                x1="1212.4"
                y1="190.2"
                x2="1251.8"
                y2="212.9"/>
            </g>
            <line
              className="st1"
              x1="1252.6"
              y1="122.1"
              x2="1252.6"
              y2="91.8"/>
            <line
              className="st1"
              x1="1224.3"
              y1="184.8"
              x2="1250.6"
              y2="200"/>
            <line
              className="st1"
              x1="1213.2"
              y1="69.2"
              x2="1213.2"
              y2="23.7"/>
            <line
              className="st1"
              x1="1292"
              y1="69.2"
              x2="1292"
              y2="23.7"/>
            <line
              className="st1"
              x1="1292"
              y1="23.7"
              x2="1252.6"
              y2="1"/>
            <line
              className="st1"
              x1="1292"
              y1="69.2"
              x2="1252.6"
              y2="92"/>
            <line
              className="st1"
              x1="1213.2"
              y1="69.2"
              x2="1252.6"
              y2="92"/>
            <g>
              <line
                className="st1"
                x1="1330.6"
                y1="255.8"
                x2="1330.6"
                y2="210.3"/>
              <line
                className="st1"
                x1="1330.6"
                y1="210.3"
                x2="1370"
                y2="187.5"/>
              <line
                className="st1"
                x1="1409.5"
                y1="255.8"
                x2="1409.5"
                y2="210.3"/>
              <line
                className="st1"
                x1="1409.5"
                y1="210.3"
                x2="1370"
                y2="187.5"/>
              <line
                className="st1"
                x1="1409.5"
                y1="255.8"
                x2="1370"
                y2="278.5"/>
              <line
                className="st1"
                x1="1330.6"
                y1="255.8"
                x2="1370"
                y2="278.5"/>
            </g>
            <line
              className="st1"
              x1="1341.3"
              y1="248.2"
              x2="1341.3"
              y2="217.8"/>
            <line
              className="st1"
              x1="1290.7"
              y1="189.5"
              x2="1331.1"
              y2="210.4"/>
            <line
              className="st1"
              x1="1370"
              y1="185.3"
              x2="1370"
              y2="139.8"/>
            <line
              className="st1"
              x1="1379.8"
              y1="177.7"
              x2="1379.8"
              y2="147.4"/>
          </g>
        </svg>
      </div>
      <div
        className="glow"/>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/landing/components/Background.js